import { Address } from 'viem';

const MerkleClaimAccounts: {
  [account: Address]: {
    address: Address;
    allocation: string;
    FLOOR?: string;
    gFLOOR?: string;
    sFLOOR?: string;
    aFLOOR?: string;
  };
} = {
  '0xd0faeb934d7e42d2a629a956feb48cc0d929d3ee': {
    address: '0xd0faeb934d7e42d2a629a956feb48cc0d929d3ee',
    allocation: '6872223105726999953408',
    FLOOR: '6872223105727',
  },
  '0xafa3b80da8443b357640f769134d598286b6dd78': {
    address: '0xafa3b80da8443b357640f769134d598286b6dd78',
    allocation: '4684621944152999854080',
    FLOOR: '4684621944153',
  },
  '0xa9d93a5cca9c98512c8c56547866b1db09090326': {
    address: '0xa9d93a5cca9c98512c8c56547866b1db09090326',
    allocation: '3323670816188999925760',
    FLOOR: '3323670816189',
  },
  '0x491be76b1b212ecd63ec80fcb315b4b6c397674f': {
    address: '0x491be76b1b212ecd63ec80fcb315b4b6c397674f',
    allocation: '3292476826721999912960',
    FLOOR: '3292476826722',
  },
  '0xa7dcc417c63f24f9073b667a5d7149bd38463d0f': {
    address: '0xa7dcc417c63f24f9073b667a5d7149bd38463d0f',
    allocation: '814267234790999982080',
    FLOOR: '814267234791',
  },
  '0x997f3c238b20fd9328796232b5b05740bab8a2ef': {
    address: '0x997f3c238b20fd9328796232b5b05740bab8a2ef',
    allocation: '803538183755000053760',
    FLOOR: '803538183755',
  },
  '0x74ef9db672f7b11a5d88a0046eeabb26988f980a': {
    address: '0x74ef9db672f7b11a5d88a0046eeabb26988f980a',
    allocation: '614874505999999959040',
    FLOOR: '614874506000',
  },
  '0x3e2dbda5f310aade1503557b2e7f356eaf161641': {
    address: '0x3e2dbda5f310aade1503557b2e7f356eaf161641',
    allocation: '599999995064000053248',
    FLOOR: '599999995064',
  },
  '0xc83e08964b900f7b9ab03f662b6ff317866835cf': {
    address: '0xc83e08964b900f7b9ab03f662b6ff317866835cf',
    allocation: '545018466367000018944',
    FLOOR: '545018466367',
  },
  '0x186bad94057591918c3265c4ddb12874324be8ac': {
    address: '0x186bad94057591918c3265c4ddb12874324be8ac',
    allocation: '506259599602000003072',
    FLOOR: '506259599602',
  },
  '0x8e4fd0a080818377adef093d99392813c3526298': {
    address: '0x8e4fd0a080818377adef093d99392813c3526298',
    allocation: '404103952429000032256',
    FLOOR: '404103952429',
  },
  '0x8a9d49a6e9d037843560091fc280b9ff9819e462': {
    address: '0x8a9d49a6e9d037843560091fc280b9ff9819e462',
    allocation: '401428462432000016384',
    FLOOR: '401428462432',
  },
  '0xb4009f0234f80a0f37ff92dd924b76c49e4567c2': {
    address: '0xb4009f0234f80a0f37ff92dd924b76c49e4567c2',
    allocation: '357050165872999989248',
    FLOOR: '357050165873',
  },
  '0x339e51c801aadcb61c1bad16d80d268b57f75f29': {
    address: '0x339e51c801aadcb61c1bad16d80d268b57f75f29',
    allocation: '336816120679999995904',
    FLOOR: '336816120680',
  },
  '0x75e89d5979e4f6fba9f97c104c2f0afb3f1dcb88': {
    address: '0x75e89d5979e4f6fba9f97c104c2f0afb3f1dcb88',
    allocation: '306717742005000011776',
    FLOOR: '306717742005',
  },
  '0xe2a6ffd1c210bee89348e6074796ecb0f42d8d91': {
    address: '0xe2a6ffd1c210bee89348e6074796ecb0f42d8d91',
    allocation: '250980956097999994880',
    FLOOR: '250980956098',
  },
  '0x54ec48ed66ac35ce2b1d012574250b9bf6306fa6': {
    address: '0x54ec48ed66ac35ce2b1d012574250b9bf6306fa6',
    allocation: '230968487692000002048',
    FLOOR: '230968487692',
  },
  '0x7c29ad60ada4b7aa75a339d4d9055bf1fb17ea1a': {
    address: '0x7c29ad60ada4b7aa75a339d4d9055bf1fb17ea1a',
    allocation: '204611375271999995904',
    FLOOR: '204611375272',
  },
  '0xe281b9d3de7a5b178961f38a4a31f1a6447304d8': {
    address: '0xe281b9d3de7a5b178961f38a4a31f1a6447304d8',
    allocation: '196988370772999995392',
    FLOOR: '196988370773',
  },
  '0xe66842c8b0fcae89f70695410b644531909ac04f': {
    address: '0xe66842c8b0fcae89f70695410b644531909ac04f',
    allocation: '177726618924999999488',
    FLOOR: '177726618925',
  },
  '0x4938e19b775c9ec210d2a0dc1ff4f4e239c8460d': {
    address: '0x4938e19b775c9ec210d2a0dc1ff4f4e239c8460d',
    allocation: '157775093554000003072',
    FLOOR: '157775093554',
  },
  '0x1f2008a4ebe69c39bb5b94d54696c07654ab0ca3': {
    address: '0x1f2008a4ebe69c39bb5b94d54696c07654ab0ca3',
    allocation: '150782000000000000000',
    FLOOR: '150782000000',
  },
  '0x953cc221d2d43ba9b7eb9bdf17617aea39cea774': {
    address: '0x953cc221d2d43ba9b7eb9bdf17617aea39cea774',
    allocation: '147900167700999995392',
    FLOOR: '147900167701',
  },
  '0x4f368dfb630ba2107e51babd062657dc7cb6381f': {
    address: '0x4f368dfb630ba2107e51babd062657dc7cb6381f',
    allocation: '146538756659000000512',
    FLOOR: '146538756659',
  },
  '0x19c95907f08c8324aaa69945835a02fe75166345': {
    address: '0x19c95907f08c8324aaa69945835a02fe75166345',
    allocation: '133025584244999995392',
    FLOOR: '133025584245',
  },
  '0x6f0e9e7c29dd34a4e2f8e4da140d88b1ea0d6ffe': {
    address: '0x6f0e9e7c29dd34a4e2f8e4da140d88b1ea0d6ffe',
    allocation: '125353659142000001024',
    FLOOR: '125353659142',
  },
  '0xc2e3a84f83a2936c9470b62269a45c41bd23e87c': {
    address: '0xc2e3a84f83a2936c9470b62269a45c41bd23e87c',
    allocation: '81792803578999996416',
    FLOOR: '81792803579',
  },
  '0xa559c5217e0d1d418d2bd0c6e6eebcf0231f7cbd': {
    address: '0xa559c5217e0d1d418d2bd0c6e6eebcf0231f7cbd',
    allocation: '76277848037000003584',
    FLOOR: '76277848037',
  },
  '0x04594b367a3264db31c109e0f650825b3695d88a': {
    address: '0x04594b367a3264db31c109e0f650825b3695d88a',
    allocation: '73359035759000002560',
    FLOOR: '73359035759',
  },
  '0xbfc948537e1fb11e40b5cd952d70773dd691e4d9': {
    address: '0xbfc948537e1fb11e40b5cd952d70773dd691e4d9',
    allocation: '66157661852000002048',
    FLOOR: '66157661852',
  },
  '0x2848dee50c28f4d239789cec2b19c01b22b36581': {
    address: '0x2848dee50c28f4d239789cec2b19c01b22b36581',
    allocation: '59415158336999997440',
    FLOOR: '59415158337',
  },
  '0x82844499bf59ba770aa084d60b6e88d810ca5264': {
    address: '0x82844499bf59ba770aa084d60b6e88d810ca5264',
    allocation: '57430636319000002560',
    FLOOR: '57430636319',
  },
  '0xb9b8ef61b7851276b0239757a039d54a23804cbb': {
    address: '0xb9b8ef61b7851276b0239757a039d54a23804cbb',
    allocation: '55924778210000003072',
    FLOOR: '55924778210',
  },
  '0x5e52994bab5d6180f9c89c2da398412952b2c22e': {
    address: '0x5e52994bab5d6180f9c89c2da398412952b2c22e',
    allocation: '54284709590000001024',
    FLOOR: '54284709590',
  },
  '0x27b5baff34b62498c4e69c0d353af99401ef8104': {
    address: '0x27b5baff34b62498c4e69c0d353af99401ef8104',
    allocation: '50000000000000000000',
    FLOOR: '50000000000',
  },
  '0xc3a97bab7edeae2ad1922b31d921ffbf2ee40e03': {
    address: '0xc3a97bab7edeae2ad1922b31d921ffbf2ee40e03',
    allocation: '50000000000000000000',
    FLOOR: '50000000000',
  },
  '0x23d6efa707f7f8b0a086938f75955203b048c5d0': {
    address: '0x23d6efa707f7f8b0a086938f75955203b048c5d0',
    allocation: '50000000000000000000',
    FLOOR: '50000000000',
  },
  '0x47eeb072a8dae3ab80b1e6123a44ecc80d2c49ff': {
    address: '0x47eeb072a8dae3ab80b1e6123a44ecc80d2c49ff',
    allocation: '48339882832999997440',
    FLOOR: '48339882833',
  },
  '0x915e54f30fa7c05bd58b1d8c2fb942e0966a2843': {
    address: '0x915e54f30fa7c05bd58b1d8c2fb942e0966a2843',
    allocation: '39836809635000000512',
    FLOOR: '39836809635',
  },
  '0x62769b5fd26c10fa14eee12a4edbf800f7d6a289': {
    address: '0x62769b5fd26c10fa14eee12a4edbf800f7d6a289',
    allocation: '39311076835999997952',
    FLOOR: '39311076836',
  },
  '0x67e77561035265311e6895063926b2f2cec127a2': {
    address: '0x67e77561035265311e6895063926b2f2cec127a2',
    allocation: '38127537398999998464',
    FLOOR: '38127537399',
  },
  '0x81ee48e37a5dccff912608310a88e3644dd76c61': {
    address: '0x81ee48e37a5dccff912608310a88e3644dd76c61',
    allocation: '35764701310000001024',
    FLOOR: '35764701310',
  },
  '0xfe638ed26aab68ae739b08c0882ea8383c06cd38': {
    address: '0xfe638ed26aab68ae739b08c0882ea8383c06cd38',
    allocation: '35746414227000000512',
    FLOOR: '35746414227',
  },
  '0xb386c1d831eed803f5e8f274a59c91c4c22eeac0': {
    address: '0xb386c1d831eed803f5e8f274a59c91c4c22eeac0',
    allocation: '32176358643000000512',
    FLOOR: '32176358643',
  },
  '0x382ffce2287252f930e1c8dc9328dac5bf282ba1': {
    address: '0x382ffce2287252f930e1c8dc9328dac5bf282ba1',
    allocation: '31830284689000001536',
    FLOOR: '31830284689',
  },
  '0x79b4a4fd3d4e8f7808eb2b0d828d8ea26cd7ee11': {
    address: '0x79b4a4fd3d4e8f7808eb2b0d828d8ea26cd7ee11',
    allocation: '31529112793999998976',
    FLOOR: '31529112794',
  },
  '0x5ddcd3a54cde0baca2696b2ad2712260957f0df3': {
    address: '0x5ddcd3a54cde0baca2696b2ad2712260957f0df3',
    allocation: '22855226233000001536',
    FLOOR: '22855226233',
  },
  '0xa67e9f021b9d208f7e3365b2a155e3c55b27de71': {
    address: '0xa67e9f021b9d208f7e3365b2a155e3c55b27de71',
    allocation: '22646378638000001024',
    FLOOR: '22646378638',
  },
  '0x28b53a51c42ac5c047465fbfd8f6f86e1ca24776': {
    address: '0x28b53a51c42ac5c047465fbfd8f6f86e1ca24776',
    allocation: '22352166579999997952',
    FLOOR: '22352166580',
  },
  '0x9008d19f58aabd9ed0d60971565aa8510560ab41': {
    address: '0x9008d19f58aabd9ed0d60971565aa8510560ab41',
    allocation: '28573523056000000000',
    FLOOR: '22327272384',
    aFLOOR: '6246250672',
  },
  '0xbf9b99c92c2c36c809e072ce668c2b70f74ff073': {
    address: '0xbf9b99c92c2c36c809e072ce668c2b70f74ff073',
    allocation: '21557924323999997952',
    FLOOR: '21557924324',
  },
  '0x3409e1e2b135f2e454c4a735ed631e144dd47f04': {
    address: '0x3409e1e2b135f2e454c4a735ed631e144dd47f04',
    allocation: '20000000000000000000',
    FLOOR: '20000000000',
  },
  '0x633c7f76a13de224194531da911ea5a9fec07faf': {
    address: '0x633c7f76a13de224194531da911ea5a9fec07faf',
    allocation: '18855520246999998464',
    FLOOR: '18855520247',
  },
  '0x2e412ff6f9d0f5b6ab8f79b3960a0b73551a28dd': {
    address: '0x2e412ff6f9d0f5b6ab8f79b3960a0b73551a28dd',
    allocation: '18250000000000000000',
    FLOOR: '18250000000',
  },
  '0x507e2135da72698044a8e6ff042324a18d73597b': {
    address: '0x507e2135da72698044a8e6ff042324a18d73597b',
    allocation: '15544577772000000000',
    FLOOR: '15544577772',
  },
  '0xcb21943babc88d518eb551243ca3281b8affd8ac': {
    address: '0xcb21943babc88d518eb551243ca3281b8affd8ac',
    allocation: '15000000000000000000',
    FLOOR: '15000000000',
  },
  '0xc1c3f882430a73046a0efb3081cd56a123cac69a': {
    address: '0xc1c3f882430a73046a0efb3081cd56a123cac69a',
    allocation: '15000000000000000000',
    FLOOR: '15000000000',
  },
  '0x133e55820cd8577b8b51049b988cf141122edaff': {
    address: '0x133e55820cd8577b8b51049b988cf141122edaff',
    allocation: '14887370099000000512',
    FLOOR: '14887370099',
  },
  '0x63dd696cd80d9473299f79373bffeb6a6f40f55d': {
    address: '0x63dd696cd80d9473299f79373bffeb6a6f40f55d',
    allocation: '14445856456999999488',
    FLOOR: '14445856457',
  },
  '0xb7b5b1ace6cd0ac08132c1eab48ba9d8c1584334': {
    address: '0xb7b5b1ace6cd0ac08132c1eab48ba9d8c1584334',
    allocation: '13700851604999999488',
    FLOOR: '13700851605',
  },
  '0xb3f2b0001a4a82e6ed9dab52224da11788798cdd': {
    address: '0xb3f2b0001a4a82e6ed9dab52224da11788798cdd',
    allocation: '12872736344000000000',
    FLOOR: '12872736344',
  },
  '0xe94c033b5ff753b3ad6c265a90afd017d532d9fd': {
    address: '0xe94c033b5ff753b3ad6c265a90afd017d532d9fd',
    allocation: '12052054588999999488',
    FLOOR: '12052054589',
  },
  '0x85ff148abef203f494ff1df1ff2fb29fbc2353b0': {
    address: '0x85ff148abef203f494ff1df1ff2fb29fbc2353b0',
    allocation: '11854448623000000512',
    FLOOR: '11854448623',
  },
  '0x7d9ebe0d82fa50095d193038712711668d549ef4': {
    address: '0x7d9ebe0d82fa50095d193038712711668d549ef4',
    allocation: '11699006390000001024',
    FLOOR: '11699006390',
  },
  '0xdd9f24efc84d93deef3c8745c837ab63e80abd27': {
    address: '0xdd9f24efc84d93deef3c8745c837ab63e80abd27',
    allocation: '12025409261000001536',
    FLOOR: '10999029390',
    aFLOOR: '1026379871',
  },
  '0xfce2ddbbe54363b321eb10486e7c19ebb173a63a': {
    address: '0xfce2ddbbe54363b321eb10486e7c19ebb173a63a',
    allocation: '10937959000000000000',
    FLOOR: '10937959000',
  },
  '0x688b5c7b549339922c0d2243debe2fe921a1a488': {
    address: '0x688b5c7b549339922c0d2243debe2fe921a1a488',
    allocation: '10630494727000000512',
    FLOOR: '10630494727',
  },
  '0x774bb1dbe6d16d324481d698ccc05e1afb327e6d': {
    address: '0x774bb1dbe6d16d324481d698ccc05e1afb327e6d',
    allocation: '10199461719000000512',
    FLOOR: '10199461719',
  },
  '0x4659e5375ee2e47b4196951320aebf074c6d1cbd': {
    address: '0x4659e5375ee2e47b4196951320aebf074c6d1cbd',
    allocation: '10000000000000000000',
    FLOOR: '10000000000',
  },
  '0x7b2eb0fa5ca1b667c9c55d0e94c28059b9b86185': {
    address: '0x7b2eb0fa5ca1b667c9c55d0e94c28059b9b86185',
    allocation: '10000000000000000000',
    FLOOR: '10000000000',
  },
  '0x89a28d4e176f6a49929f20633727aa18139aeabe': {
    address: '0x89a28d4e176f6a49929f20633727aa18139aeabe',
    allocation: '9740000000000000000',
    FLOOR: '9740000000',
  },
  '0x0d2f55a1e3216a67155f18ae41e0ce52d0b253d9': {
    address: '0x0d2f55a1e3216a67155f18ae41e0ce52d0b253d9',
    allocation: '9256118912999999488',
    FLOOR: '9256118913',
  },
  '0x84d99aa569d93a9ca187d83734c8c4a519c4e9b1': {
    address: '0x84d99aa569d93a9ca187d83734c8c4a519c4e9b1',
    allocation: '7971830399000000512',
    FLOOR: '7971830399',
  },
  '0x97d329254060cd5ba46c88118564c95010de8425': {
    address: '0x97d329254060cd5ba46c88118564c95010de8425',
    allocation: '7449146954000000000',
    FLOOR: '7449146954',
  },
  '0x07b82a84edd794b3bf3f51caaa7f0f5041dab9ac': {
    address: '0x07b82a84edd794b3bf3f51caaa7f0f5041dab9ac',
    allocation: '7151536383000000512',
    FLOOR: '7151536383',
  },
  '0x0eaf8cbc4e6988abfeca5b4a2c34df86a2746323': {
    address: '0x0eaf8cbc4e6988abfeca5b4a2c34df86a2746323',
    allocation: '7057896728000000000',
    FLOOR: '7057896728',
  },
  '0x5642c5b06fad677dac1cde9f00f8f1e16508d7fc': {
    address: '0x5642c5b06fad677dac1cde9f00f8f1e16508d7fc',
    allocation: '6454108763000000512',
    FLOOR: '6454108763',
  },
  '0xb830ff5b8e08f179cc5d45905cc71166e5dc21b5': {
    address: '0xb830ff5b8e08f179cc5d45905cc71166e5dc21b5',
    allocation: '5887952318000000000',
    FLOOR: '5887952318',
  },
  '0x0eabf6369e611d1034a476dd61466dffbf8e4c3a': {
    address: '0x0eabf6369e611d1034a476dd61466dffbf8e4c3a',
    allocation: '5775383767000000512',
    FLOOR: '5775383767',
  },
  '0x6a2172bb35f054a2ea44ef175062b4d327c9d8a4': {
    address: '0x6a2172bb35f054a2ea44ef175062b4d327c9d8a4',
    allocation: '5490736412999999488',
    FLOOR: '5490736413',
  },
  '0x83c2cdd97a2413ae305d92f1e819562af8e2ba68': {
    address: '0x83c2cdd97a2413ae305d92f1e819562af8e2ba68',
    allocation: '5433471082000000000',
    FLOOR: '5433471082',
  },
  '0x832b5b2021b56c56d4d7d3a76b20b702603a6133': {
    address: '0x832b5b2021b56c56d4d7d3a76b20b702603a6133',
    allocation: '5212041000000000000',
    FLOOR: '5212041000',
  },
  '0x289ab0c2a11fbd8cd348283b6274314ff5f18559': {
    address: '0x289ab0c2a11fbd8cd348283b6274314ff5f18559',
    allocation: '5137586279000000512',
    FLOOR: '5137586279',
  },
  '0x27d9d2eb65db60bada6ba5ffb4aaad372e45bf0c': {
    address: '0x27d9d2eb65db60bada6ba5ffb4aaad372e45bf0c',
    allocation: '5000000000000000000',
    FLOOR: '5000000000',
  },
  '0xc12a9f690aff7134f9d7ebe9265e78aff6ae8aad': {
    address: '0xc12a9f690aff7134f9d7ebe9265e78aff6ae8aad',
    allocation: '4927087712999999488',
    FLOOR: '4927087713',
  },
  '0x4d00af255c2886da69287c6fadf059ac874e1933': {
    address: '0x4d00af255c2886da69287c6fadf059ac874e1933',
    allocation: '4839095308000000000',
    FLOOR: '4839095308',
  },
  '0xa3ab02c8d67c091d0ac540148801994b75a42592': {
    address: '0xa3ab02c8d67c091d0ac540148801994b75a42592',
    allocation: '4801668270000000000',
    FLOOR: '4801668270',
  },
  '0x9c9e06f67c7f947ea5c1c45ba0e9e9f975a2b067': {
    address: '0x9c9e06f67c7f947ea5c1c45ba0e9e9f975a2b067',
    allocation: '4680725200999999488',
    FLOOR: '4680725201',
  },
  '0x000000000000000000000000000000000000dead': {
    address: '0x000000000000000000000000000000000000dead',
    allocation: '4602263314000000000',
    FLOOR: '4602263314',
  },
  '0xccf80ab70fe9197604fdf2b9f2f2f602bed31fae': {
    address: '0xccf80ab70fe9197604fdf2b9f2f2f602bed31fae',
    allocation: '4601850929000000000',
    FLOOR: '4601850929',
  },
  '0xd5b927956057075377263aab7f8afc12f85100db': {
    address: '0xd5b927956057075377263aab7f8afc12f85100db',
    allocation: '4353808886000000000',
    FLOOR: '4353808886',
  },
  '0xe2a54c41ba4aca8140fe60a883393d31752d5195': {
    address: '0xe2a54c41ba4aca8140fe60a883393d31752d5195',
    allocation: '4250278724000000000',
    FLOOR: '4250278724',
  },
  '0x9a4adb8c0aebcf7d60c16ee8cf19b53d29e1890a': {
    address: '0x9a4adb8c0aebcf7d60c16ee8cf19b53d29e1890a',
    allocation: '4000000000000000000',
    FLOOR: '4000000000',
  },
  '0x0b8a49d816cc709b6eadb09498030ae3416b66dc': {
    address: '0x0b8a49d816cc709b6eadb09498030ae3416b66dc',
    allocation: '3859209253000000000',
    FLOOR: '3859209253',
  },
  '0xdb69c8966a625b1248c914dfc437ebbcd9e28a25': {
    address: '0xdb69c8966a625b1248c914dfc437ebbcd9e28a25',
    allocation: '3844938869000000000',
    FLOOR: '3844938869',
  },
  '0xe5402b78f5ae1f39c5df20778d533c7bc6bffec8': {
    address: '0xe5402b78f5ae1f39c5df20778d533c7bc6bffec8',
    allocation: '3624621049000000000',
    FLOOR: '3624621049',
  },
  '0x6252bb54a4025943bbe3b6ae56fc9058faefca31': {
    address: '0x6252bb54a4025943bbe3b6ae56fc9058faefca31',
    allocation: '3440000000000000000',
    FLOOR: '3440000000',
  },
  '0xe5bdb4c46dd21abcb447d511be81b50a2bcac149': {
    address: '0xe5bdb4c46dd21abcb447d511be81b50a2bcac149',
    allocation: '3024271490000000000',
    FLOOR: '3024271490',
  },
  '0x981ba820974f9d581db0b77ecccdb15fa0a82f48': {
    address: '0x981ba820974f9d581db0b77ecccdb15fa0a82f48',
    allocation: '2819175262000000000',
    FLOOR: '2819175262',
  },
  '0x430e35e8b96e30243ef7941475b2b7b141ab3033': {
    address: '0x430e35e8b96e30243ef7941475b2b7b141ab3033',
    allocation: '2808600000000000000',
    FLOOR: '2808600000',
  },
  '0x97bb9967bf7b3de7000b3ec77108c579a6f186bd': {
    address: '0x97bb9967bf7b3de7000b3ec77108c579a6f186bd',
    allocation: '2772480937000000000',
    FLOOR: '2772480937',
  },
  '0xc7445e911ea39db4f6e55e2e49bb84fc9cb4f895': {
    address: '0xc7445e911ea39db4f6e55e2e49bb84fc9cb4f895',
    allocation: '2708065653000000000',
    FLOOR: '2708065653',
  },
  '0x3367e91f831aec3ae7fc24e5309e09dd086da595': {
    address: '0x3367e91f831aec3ae7fc24e5309e09dd086da595',
    allocation: '2361249047000000000',
    FLOOR: '2361249047',
  },
  '0x4436b0b26a76ccd25f6b97324c42df4b0f0ed3ab': {
    address: '0x4436b0b26a76ccd25f6b97324c42df4b0f0ed3ab',
    allocation: '33179095810189750272',
    FLOOR: '2060179067',
    gFLOOR: '7818823302308982784',
  },
  '0x613e6b7450518065289d91d06c43f67ba14f5bb7': {
    address: '0x613e6b7450518065289d91d06c43f67ba14f5bb7',
    allocation: '2000000000000000000',
    FLOOR: '2000000000',
  },
  '0x54116f8e2bec28c8d6f9cbb0cadfd1e693bb8da9': {
    address: '0x54116f8e2bec28c8d6f9cbb0cadfd1e693bb8da9',
    allocation: '2000000000000000000',
    FLOOR: '2000000000',
  },
  '0xd1742b3c4fbb096990c8950fa635aec75b30781a': {
    address: '0xd1742b3c4fbb096990c8950fa635aec75b30781a',
    allocation: '1967540511000000000',
    FLOOR: '1967540511',
  },
  '0xcfded562ba095fb6e090bba9616093c2777e8892': {
    address: '0xcfded562ba095fb6e090bba9616093c2777e8892',
    allocation: '1854949777000000000',
    FLOOR: '1854949777',
  },
  '0xd43cf02bea3b50a188a2cd7b2a8435a493e7440f': {
    address: '0xd43cf02bea3b50a188a2cd7b2a8435a493e7440f',
    allocation: '1845132958000000000',
    FLOOR: '1845132958',
  },
  '0x96c195f6643a3d797cb90cb6ba0ae2776d51b5f3': {
    address: '0x96c195f6643a3d797cb90cb6ba0ae2776d51b5f3',
    allocation: '1722651637000000000',
    FLOOR: '1722651637',
  },
  '0xf6711c3e359dbe942907709779b44b473f3c4358': {
    address: '0xf6711c3e359dbe942907709779b44b473f3c4358',
    allocation: '1689872372000000000',
    FLOOR: '1689872372',
  },
  '0x0c1198fbdb19840a2a2989b025ce5405d905139b': {
    address: '0x0c1198fbdb19840a2a2989b025ce5405d905139b',
    allocation: '1612963153000000000',
    FLOOR: '1612963153',
  },
  '0xfcba80c7076fa2f41c975022e80c89c372158123': {
    address: '0xfcba80c7076fa2f41c975022e80c89c372158123',
    allocation: '1260404452000000000',
    FLOOR: '1260404452',
  },
  '0xc6c2d5ee69745a1e9f2d1a06e0ef0788bd924302': {
    address: '0xc6c2d5ee69745a1e9f2d1a06e0ef0788bd924302',
    allocation: '1188516420000000000',
    FLOOR: '1188516420',
  },
  '0x12f7a49717149a8f4b883358643390babd7b34ee': {
    address: '0x12f7a49717149a8f4b883358643390babd7b34ee',
    allocation: '1183820987000000000',
    FLOOR: '1183820987',
  },
  '0xc6b5483667e7b81c4e3d20e86711e8111db41749': {
    address: '0xc6b5483667e7b81c4e3d20e86711e8111db41749',
    allocation: '36162880956000002048',
    FLOOR: '1162880956',
    sFLOOR: '35000000000',
  },
  '0x30cb353847c13983d0576c04b2d5d762d813cc26': {
    address: '0x30cb353847c13983d0576c04b2d5d762d813cc26',
    allocation: '1058064615000000000',
    FLOOR: '1058064615',
  },
  '0x8f3dcc0da015a0af2b964bb5c4d54bfc37fe2cd8': {
    address: '0x8f3dcc0da015a0af2b964bb5c4d54bfc37fe2cd8',
    allocation: '1054700000000000000',
    FLOOR: '1054700000',
  },
  '0xfb47f7ef2205bea1eaf6e80f1953e54971309608': {
    address: '0xfb47f7ef2205bea1eaf6e80f1953e54971309608',
    allocation: '101025265306999996416',
    FLOOR: '1025265307',
    sFLOOR: '100000000000',
  },
  '0x8a4c30ec99261113ff7172e30cfd5abfd3ef0386': {
    address: '0x8a4c30ec99261113ff7172e30cfd5abfd3ef0386',
    allocation: '1000000000000000000',
    FLOOR: '1000000000',
  },
  '0x04fe82a2a3284f629bb501e78e6ddf38702d129c': {
    address: '0x04fe82a2a3284f629bb501e78e6ddf38702d129c',
    allocation: '1000000000000000000',
    FLOOR: '1000000000',
  },
  '0x753e13f134810dfbe55296a910c7961aa1b839c4': {
    address: '0x753e13f134810dfbe55296a910c7961aa1b839c4',
    allocation: '1000000000000000000',
    FLOOR: '1000000000',
  },
  '0x4a41d76b0524a3989998380c033f12bfeb5f7201': {
    address: '0x4a41d76b0524a3989998380c033f12bfeb5f7201',
    allocation: '992879386000000000',
    FLOOR: '992879386',
  },
  '0xc3ba8c5f41cb8f7ecfef2beb55154a7e9eabea55': {
    address: '0xc3ba8c5f41cb8f7ecfef2beb55154a7e9eabea55',
    allocation: '154755365647999991808',
    FLOOR: '987898041',
    sFLOOR: '153767467607',
  },
  '0xdb42dd6f0871728596636461ac2ab0755ca7f614': {
    address: '0xdb42dd6f0871728596636461ac2ab0755ca7f614',
    allocation: '983456806000000000',
    FLOOR: '983456806',
  },
  '0xd5a2ec9468a5de6e5f3f7d787b53994182775c1b': {
    address: '0xd5a2ec9468a5de6e5f3f7d787b53994182775c1b',
    allocation: '120957466206000005120',
    FLOOR: '957466206',
    sFLOOR: '120000000000',
  },
  '0xdefce36084f1f1c7af1866d0ff73a547f7f5d3e9': {
    address: '0xdefce36084f1f1c7af1866d0ff73a547f7f5d3e9',
    allocation: '955854261000000000',
    FLOOR: '955854261',
  },
  '0xf8116a8b5165789c999c4bb4adf7c394355aaa5e': {
    address: '0xf8116a8b5165789c999c4bb4adf7c394355aaa5e',
    allocation: '911859199000000000',
    FLOOR: '911859199',
  },
  '0x12638372a53c851438565d0c622d52589a817631': {
    address: '0x12638372a53c851438565d0c622d52589a817631',
    allocation: '882127186000000000',
    FLOOR: '882127186',
  },
  '0x64792ea7c648eccc079494764db42398c0251d12': {
    address: '0x64792ea7c648eccc079494764db42398c0251d12',
    allocation: '897997610000000000',
    FLOOR: '877997610',
    aFLOOR: '20000000',
  },
  '0xf4cb25a1ff50e319c267b3e51cbec2699fb2a43b': {
    address: '0xf4cb25a1ff50e319c267b3e51cbec2699fb2a43b',
    allocation: '833048475000000000',
    FLOOR: '833048475',
  },
  '0xbf5918c39f048d5e4d6aed16f6644f9b46b562c2': {
    address: '0xbf5918c39f048d5e4d6aed16f6644f9b46b562c2',
    allocation: '808579015000000000',
    FLOOR: '808579015',
  },
  '0x8ff1f482e9b7643f7fbcc924779fd5c372371b93': {
    address: '0x8ff1f482e9b7643f7fbcc924779fd5c372371b93',
    allocation: '787933014000000000',
    FLOOR: '787933014',
  },
  '0x73c2b84daffd1d65b679dbd47929ce1dc136a864': {
    address: '0x73c2b84daffd1d65b679dbd47929ce1dc136a864',
    allocation: '744500000000000000',
    FLOOR: '744500000',
  },
  '0x45afe933cfc9a13fa668ad79f9605b7063dfdb92': {
    address: '0x45afe933cfc9a13fa668ad79f9605b7063dfdb92',
    allocation: '716597616000000000',
    FLOOR: '716597616',
  },
  '0x69426f6d2fa447b2202b205bb24590a3412908bd': {
    address: '0x69426f6d2fa447b2202b205bb24590a3412908bd',
    allocation: '711580931000000000',
    FLOOR: '711580931',
  },
  '0xa1753ac7a7490466f8729564901187f851e6fa27': {
    address: '0xa1753ac7a7490466f8729564901187f851e6fa27',
    allocation: '711576708000000000',
    FLOOR: '711576708',
  },
  '0xad30f7eebd9bd5150a256f47da41d4403033cdf0': {
    address: '0xad30f7eebd9bd5150a256f47da41d4403033cdf0',
    allocation: '700000000000000000',
    FLOOR: '700000000',
  },
  '0x4a183b7ed67b9e14b3f45abfb2cf44ed22c29e54': {
    address: '0x4a183b7ed67b9e14b3f45abfb2cf44ed22c29e54',
    allocation: '628367165000000000',
    FLOOR: '628367165',
  },
  '0xa2917120c698fb5f2a03e3fd3524bda85a3eaef6': {
    address: '0xa2917120c698fb5f2a03e3fd3524bda85a3eaef6',
    allocation: '614539861000000000',
    FLOOR: '614539861',
  },
  '0x7b2a9107d2e826328c58c4cbb60eecdfb5dd0550': {
    address: '0x7b2a9107d2e826328c58c4cbb60eecdfb5dd0550',
    allocation: '574221866000000000',
    FLOOR: '574221866',
  },
  '0xe2c1e1058d2dfdea8fa534b256eb863b46b9b42a': {
    address: '0xe2c1e1058d2dfdea8fa534b256eb863b46b9b42a',
    allocation: '573675640000000000',
    FLOOR: '573675640',
  },
  '0x00000dad88697c5ca363fef81db9a682cfe17e72': {
    address: '0x00000dad88697c5ca363fef81db9a682cfe17e72',
    allocation: '549251849000000000',
    FLOOR: '549251849',
  },
  '0x4130d9c537bb5a6eb47e2f23fbc78f307cab95e1': {
    address: '0x4130d9c537bb5a6eb47e2f23fbc78f307cab95e1',
    allocation: '529677543000000000',
    FLOOR: '529677543',
  },
  '0x4ff244c515837e284909a74934afe75695b7ba70': {
    address: '0x4ff244c515837e284909a74934afe75695b7ba70',
    allocation: '471251894000000000',
    FLOOR: '471251894',
  },
  '0x143914837c8d106239b271dac1ac572066f45a6b': {
    address: '0x143914837c8d106239b271dac1ac572066f45a6b',
    allocation: '448694209000000000',
    FLOOR: '448694209',
  },
  '0x0573e8b5dca086cc6780937a5403d95df0036995': {
    address: '0x0573e8b5dca086cc6780937a5403d95df0036995',
    allocation: '279690930681397739520',
    FLOOR: '398041219',
    gFLOOR: '70174092829748174848',
  },
  '0x393ce05d52ad57a349aade03a27293676554d64d': {
    address: '0x393ce05d52ad57a349aade03a27293676554d64d',
    allocation: '387590722000000000',
    FLOOR: '387590722',
  },
  '0xcd75c4bf850f663b1924e398d4433bff6774c4d5': {
    address: '0xcd75c4bf850f663b1924e398d4433bff6774c4d5',
    allocation: '284670999000000000',
    FLOOR: '284670999',
  },
  '0x050f788d09395724777a67dd08be127cf70dd238': {
    address: '0x050f788d09395724777a67dd08be127cf70dd238',
    allocation: '254710167000000000',
    FLOOR: '254710167',
  },
  '0xf7a9a18d0a24c390ec230284af5fff55ec6b3d4a': {
    address: '0xf7a9a18d0a24c390ec230284af5fff55ec6b3d4a',
    allocation: '22235524400000000000',
    FLOOR: '235524400',
    sFLOOR: '22000000000',
  },
  '0xfa0893d716e473ec6b8afbb6d167524e1ad40b90': {
    address: '0xfa0893d716e473ec6b8afbb6d167524e1ad40b90',
    allocation: '162186931000000000',
    FLOOR: '162186931',
  },
  '0x6c1c420c04f4d563d6588a97693af902b87be5f1': {
    address: '0x6c1c420c04f4d563d6588a97693af902b87be5f1',
    allocation: '126432715000000000',
    FLOOR: '126432715',
  },
  '0x1808cbff61bd94a1fc3f20378d471780517d0af5': {
    address: '0x1808cbff61bd94a1fc3f20378d471780517d0af5',
    allocation: '120000000000000000',
    FLOOR: '120000000',
  },
  '0xef13101c5bbd737cfb2bf00bbd38c626ad6952f7': {
    address: '0xef13101c5bbd737cfb2bf00bbd38c626ad6952f7',
    allocation: '112012946000000000',
    FLOOR: '112012946',
  },
  '0x00000000726422a6fecb4759b44d47e48cf746aa': {
    address: '0x00000000726422a6fecb4759b44d47e48cf746aa',
    allocation: '102544219000000000',
    FLOOR: '102544219',
  },
  '0x78f21c46e649e1a77af1b7bb86470909de2ada93': {
    address: '0x78f21c46e649e1a77af1b7bb86470909de2ada93',
    allocation: '93472507000000000',
    FLOOR: '93472507',
  },
  '0x164a8379198a8d7155a1f0eab9baa256078d378e': {
    address: '0x164a8379198a8d7155a1f0eab9baa256078d378e',
    allocation: '1899203232313938688',
    FLOOR: '92694500',
    gFLOOR: '453896666410537344',
  },
  '0xb1720612d0131839dc489fcf20398ea925282fca': {
    address: '0xb1720612d0131839dc489fcf20398ea925282fca',
    allocation: '80372851000000000',
    FLOOR: '80371473',
    aFLOOR: '1378',
  },
  '0x3ca7b707c7ade3fa04a60746533e4433fba9327e': {
    address: '0x3ca7b707c7ade3fa04a60746533e4433fba9327e',
    allocation: '75804138000000000',
    FLOOR: '75804138',
  },
  '0xe635b15291f31c1ba6c7a6c3d26cbdf6c0f77204': {
    address: '0xe635b15291f31c1ba6c7a6c3d26cbdf6c0f77204',
    allocation: '30211017504000000000',
    FLOOR: '70518730',
    sFLOOR: '30140498774',
  },
  '0x57b3abae7e7392571396a4a91bc1ae35bbdd19d7': {
    address: '0x57b3abae7e7392571396a4a91bc1ae35bbdd19d7',
    allocation: '2940463490818989056',
    FLOOR: '64877115',
    gFLOOR: '722509139653012352',
  },
  '0x720c9244473dfc596547c1f7b6261c7112a3dad4': {
    address: '0x720c9244473dfc596547c1f7b6261c7112a3dad4',
    allocation: '51496917000000000',
    FLOOR: '51496917',
  },
  '0x02dff4217b0e4c719a1acd8783ef6c92615d0a2c': {
    address: '0x02dff4217b0e4c719a1acd8783ef6c92615d0a2c',
    allocation: '28265152010825375744',
    FLOOR: '50667497',
    gFLOOR: '7089066460760143872',
  },
  '0x9c847ec9c91ee77d317e223fa21b00dcdd95daf5': {
    address: '0x9c847ec9c91ee77d317e223fa21b00dcdd95daf5',
    allocation: '44414845000000000',
    FLOOR: '44414845',
  },
  '0x938b933b163f1a3bccc3a265f0d52266b737bb87': {
    address: '0x938b933b163f1a3bccc3a265f0d52266b737bb87',
    allocation: '10832583380999999488',
    FLOOR: '32583381',
    sFLOOR: '10800000000',
  },
  '0x524bb30d65433d4e319d877183608aa0b2f18471': {
    address: '0x524bb30d65433d4e319d877183608aa0b2f18471',
    allocation: '32494296000000000',
    FLOOR: '32494296',
  },
  '0xe1827d434538752ca08abd2c75d44e3522c772a5': {
    address: '0xe1827d434538752ca08abd2c75d44e3522c772a5',
    allocation: '60000000000000000',
    FLOOR: '30000000',
    aFLOOR: '30000000',
  },
  '0xdd524faa7520160fe60dea27105e18af840f342e': {
    address: '0xdd524faa7520160fe60dea27105e18af840f342e',
    allocation: '5424837764999999488',
    FLOOR: '24837765',
    sFLOOR: '5400000000',
  },
  '0xb0000000aa4f00af1200c8b2befb6300853f0069': {
    address: '0xb0000000aa4f00af1200c8b2befb6300853f0069',
    allocation: '10861926000000000',
    FLOOR: '10861926',
  },
  '0x5baac7ccda079839c9524b90df81720834fc039f': {
    address: '0x5baac7ccda079839c9524b90df81720834fc039f',
    allocation: '9106439000000000',
    FLOOR: '9106439',
  },
  '0xb879e2bfc51df4f25eafa7a99c1baf09baf3c020': {
    address: '0xb879e2bfc51df4f25eafa7a99c1baf09baf3c020',
    allocation: '9022156000000000',
    FLOOR: '9022156',
  },
  '0xcbdc53d424d5a2e5fef1776997352f10212c9883': {
    address: '0xcbdc53d424d5a2e5fef1776997352f10212c9883',
    allocation: '8289621000000000',
    FLOOR: '8289621',
  },
  '0x89601c127395d185f9b40fb53f53d5cf432d1fd1': {
    address: '0x89601c127395d185f9b40fb53f53d5cf432d1fd1',
    allocation: '6189143000000000',
    FLOOR: '6189143',
  },
  '0x829e69248e9099dff544b651722d96786aa4a5ac': {
    address: '0x829e69248e9099dff544b651722d96786aa4a5ac',
    allocation: '5239119000000000',
    FLOOR: '5239119',
  },
  '0x7482c861aecfe16ff7c8c55ce4cde52d5225ee8c': {
    address: '0x7482c861aecfe16ff7c8c55ce4cde52d5225ee8c',
    allocation: '5017856000000000',
    FLOOR: '5017856',
  },
  '0x912ad3ff222386d00e4e6bc55537e1d8cbb42994': {
    address: '0x912ad3ff222386d00e4e6bc55537e1d8cbb42994',
    allocation: '4680128000000000',
    FLOOR: '4680128',
  },
  '0x98df405f9cd76420e30ae9f55bff74dcea71dcea': {
    address: '0x98df405f9cd76420e30ae9f55bff74dcea71dcea',
    allocation: '3132502587000000000',
    FLOOR: '2502587',
    sFLOOR: '3130000000',
  },
  '0x3fafbe44e93bf8ebf2f77348496b3451631d2d1c': {
    address: '0x3fafbe44e93bf8ebf2f77348496b3451631d2d1c',
    allocation: '48975765456000000000',
    FLOOR: '1765456',
    gFLOOR: '11300000000000000000',
    sFLOOR: '4000000000',
  },
  '0x37387858399bae1c352ef11a35ce6a0c464c19b3': {
    address: '0x37387858399bae1c352ef11a35ce6a0c464c19b3',
    allocation: '1667455000000000',
    FLOOR: '1667455',
  },
  '0xc3f4ecf963e053eb7509642569c81deed2a3be1a': {
    address: '0xc3f4ecf963e053eb7509642569c81deed2a3be1a',
    allocation: '1305295000000000',
    FLOOR: '1305295',
  },
  '0xa10fca31a2cb432c9ac976779dc947cfdb003ef0': {
    address: '0xa10fca31a2cb432c9ac976779dc947cfdb003ef0',
    allocation: '1240562000000000',
    FLOOR: '1240562',
  },
  '0x2e9a1fc99ae7a7f5d64556d4129ef128da0ee873': {
    address: '0x2e9a1fc99ae7a7f5d64556d4129ef128da0ee873',
    allocation: '773611000000000',
    FLOOR: '773611',
  },
  '0xe5a8d5ad562c78e8c3f9fea7a2f898f169c6c729': {
    address: '0xe5a8d5ad562c78e8c3f9fea7a2f898f169c6c729',
    allocation: '23301626675874864',
    FLOOR: '687716',
    gFLOOR: '5681887104491172',
  },
  '0x00000000003b3cc22af3ae1eac0440bcee416b40': {
    address: '0x00000000003b3cc22af3ae1eac0440bcee416b40',
    allocation: '588358000000000',
    FLOOR: '588358',
  },
  '0x563bdabaa8846ec445b25bfbed88d160890a02ed': {
    address: '0x563bdabaa8846ec445b25bfbed88d160890a02ed',
    allocation: '575170000000000',
    FLOOR: '575170',
  },
  '0x6b75d8af000000e20b7a7ddf000ba900b4009a80': {
    address: '0x6b75d8af000000e20b7a7ddf000ba900b4009a80',
    allocation: '544630000000000',
    FLOOR: '544630',
  },
  '0xf0777073e6caf73437a0e3ce7ddfa5e4bd96a690': {
    address: '0xf0777073e6caf73437a0e3ce7ddfa5e4bd96a690',
    allocation: '426159000000000',
    FLOOR: '426159',
  },
  '0xeef86c2e49e11345f1a693675df9a38f7d880c8f': {
    address: '0xeef86c2e49e11345f1a693675df9a38f7d880c8f',
    allocation: '411739000000000',
    FLOOR: '411739',
  },
  '0x22d60db6f33bc1dd7cdf57770f056e193e5bd611': {
    address: '0x22d60db6f33bc1dd7cdf57770f056e193e5bd611',
    allocation: '213577000000000',
    FLOOR: '213577',
  },
  '0x5333c1d733794e02f34d5f0d88c65d03fd2e4db1': {
    address: '0x5333c1d733794e02f34d5f0d88c65d03fd2e4db1',
    allocation: '175277000000000',
    FLOOR: '175277',
  },
  '0xe1a626a3ea90d0c23984e90c95ed48fd4dbc8d59': {
    address: '0xe1a626a3ea90d0c23984e90c95ed48fd4dbc8d59',
    allocation: '130000000000000',
    FLOOR: '130000',
  },
  '0x79d899379844d35a1a1f5d51d3185dd821f44dc1': {
    address: '0x79d899379844d35a1a1f5d51d3185dd821f44dc1',
    allocation: '112052877228230',
    FLOOR: '88474',
    gFLOOR: '5924341012118',
  },
  '0x7cb5fd8cb523598c4f1324d51dcec4e54aea52b7': {
    address: '0x7cb5fd8cb523598c4f1324d51dcec4e54aea52b7',
    allocation: '87856000000000',
    FLOOR: '87856',
  },
  '0x8a4f6fb2c9a170b2a873acbba8235befa0026141': {
    address: '0x8a4f6fb2c9a170b2a873acbba8235befa0026141',
    allocation: '72765000000000',
    FLOOR: '72765',
  },
  '0x006200fb630000bb009b0083ae13fada00852a89': {
    address: '0x006200fb630000bb009b0083ae13fada00852a89',
    allocation: '64927000000000',
    FLOOR: '64927',
  },
  '0x759ec1b3326de6fd4ba316f65a6f689c4e4c3092': {
    address: '0x759ec1b3326de6fd4ba316f65a6f689c4e4c3092',
    allocation: '59291000000000',
    FLOOR: '59291',
  },
  '0x22c8c2617deef93cc9a6c6f5fccff007e1c64409': {
    address: '0x22c8c2617deef93cc9a6c6f5fccff007e1c64409',
    allocation: '57295000000000',
    FLOOR: '57295',
  },
  '0x42224e5ea581c6cbea07fdd8fa47b8240aa8ea40': {
    address: '0x42224e5ea581c6cbea07fdd8fa47b8240aa8ea40',
    allocation: '55105000000000',
    FLOOR: '55105',
  },
  '0x54b32d5365d6ea0fe441fefd0e71672f0b51186a': {
    address: '0x54b32d5365d6ea0fe441fefd0e71672f0b51186a',
    allocation: '50889000000000',
    FLOOR: '50889',
  },
  '0xfa4fc4ec2f81a4897743c5b4f45907c02ce06199': {
    address: '0xfa4fc4ec2f81a4897743c5b4f45907c02ce06199',
    allocation: '37011000000000',
    FLOOR: '37011',
  },
  '0x713187a9613e6a8a4220d0a338a724315ee83159': {
    address: '0x713187a9613e6a8a4220d0a338a724315ee83159',
    allocation: '34904000000000',
    FLOOR: '34904',
  },
  '0x888c15c949a7bb3360bf023944db440138c4946e': {
    address: '0x888c15c949a7bb3360bf023944db440138c4946e',
    allocation: '31138000000000',
    FLOOR: '31138',
  },
  '0x93ffb15d1fa91e0c320d058f00ee97f9e3c50096': {
    address: '0x93ffb15d1fa91e0c320d058f00ee97f9e3c50096',
    allocation: '25240000000000',
    FLOOR: '25240',
  },
  '0xd44942fefdbf6aa150039554034e1fec43380450': {
    address: '0xd44942fefdbf6aa150039554034e1fec43380450',
    allocation: '10411000000000',
    FLOOR: '10411',
  },
  '0xdba5b5e3578bc9375ca1f5504b167e1c468c7c39': {
    address: '0xdba5b5e3578bc9375ca1f5504b167e1c468c7c39',
    allocation: '9467000000000',
    FLOOR: '9467',
  },
  '0xd0ae3ab27489bf4e4ce73ee258081fa9264cbb17': {
    address: '0xd0ae3ab27489bf4e4ce73ee258081fa9264cbb17',
    allocation: '8259000000000',
    FLOOR: '8259',
  },
  '0xc15575651c098d5ee41063f86530db8dc715a33b': {
    address: '0xc15575651c098d5ee41063f86530db8dc715a33b',
    allocation: '6846000000000',
    FLOOR: '6846',
  },
  '0x431cbee3f459791a89510acc9cb8154f511322cd': {
    address: '0x431cbee3f459791a89510acc9cb8154f511322cd',
    allocation: '5177000000000',
    FLOOR: '5177',
  },
  '0x2ace4e9d7fe2d52b64d9ec64e120f149583d327b': {
    address: '0x2ace4e9d7fe2d52b64d9ec64e120f149583d327b',
    allocation: '4620000000000',
    FLOOR: '4620',
  },
  '0x00000000a991c429ee2ec6df19d40fe0c80088b8': {
    address: '0x00000000a991c429ee2ec6df19d40fe0c80088b8',
    allocation: '4423000000000',
    FLOOR: '4423',
  },
  '0x00000000007079010d6e70a9b6e6d70a43f58300': {
    address: '0x00000000007079010d6e70a9b6e6d70a43f58300',
    allocation: '4364000000000',
    FLOOR: '4364',
  },
  '0x08aba4a72d866c1fc1dda72508e0cd47388304ac': {
    address: '0x08aba4a72d866c1fc1dda72508e0cd47388304ac',
    allocation: '4204000000000',
    FLOOR: '4204',
  },
  '0xfa7bf14f76edb60a3e3b12536ef5e0e1ac13965e': {
    address: '0xfa7bf14f76edb60a3e3b12536ef5e0e1ac13965e',
    allocation: '4166000000000',
    FLOOR: '4166',
  },
  '0x8578ebedb49c18231ccaa41610ac5eda0a5d00ee': {
    address: '0x8578ebedb49c18231ccaa41610ac5eda0a5d00ee',
    allocation: '4000000000000',
    FLOOR: '4000',
  },
  '0xffb88b866114cc40f554a7a3a516c06962a3ec9a': {
    address: '0xffb88b866114cc40f554a7a3a516c06962a3ec9a',
    allocation: '3769000000000',
    FLOOR: '3769',
  },
  '0x615571774ec943f9d034a3f7f0ee28a518b30b0c': {
    address: '0x615571774ec943f9d034a3f7f0ee28a518b30b0c',
    allocation: '3116000000000',
    FLOOR: '3116',
  },
  '0xa392d4e3d660180e270fabfd17acba523c7a6096': {
    address: '0xa392d4e3d660180e270fabfd17acba523c7a6096',
    allocation: '914000000000',
    FLOOR: '914',
  },
  '0x493f461aead031cee2027f1b95370a692611acb9': {
    address: '0x493f461aead031cee2027f1b95370a692611acb9',
    allocation: '599000000000',
    FLOOR: '599',
  },
  '0x1ffeb270de26348f0c6e9f442bcd89ccaf1449cb': {
    address: '0x1ffeb270de26348f0c6e9f442bcd89ccaf1449cb',
    allocation: '337000000000',
    FLOOR: '337',
  },
  '0xc329c67338a17741fe1f69982f97430271ea78c8': {
    address: '0xc329c67338a17741fe1f69982f97430271ea78c8',
    allocation: '335000000000',
    FLOOR: '335',
  },
  '0xcd8c88317c214aada355a3bf4af9635751482209': {
    address: '0xcd8c88317c214aada355a3bf4af9635751482209',
    allocation: '261000000000',
    FLOOR: '261',
  },
  '0x9878644ad744a970d3598594f1cdbb1389c17826': {
    address: '0x9878644ad744a970d3598594f1cdbb1389c17826',
    allocation: '255000000000',
    FLOOR: '255',
  },
  '0xbeff716f141274afe1d1ba532dab824287e6c221': {
    address: '0xbeff716f141274afe1d1ba532dab824287e6c221',
    allocation: '248000000000',
    FLOOR: '248',
  },
  '0x353c1f0bc78fbbc245b3c93ef77b1dcc5b77d2a0': {
    address: '0x353c1f0bc78fbbc245b3c93ef77b1dcc5b77d2a0',
    allocation: '226000000000',
    FLOOR: '226',
  },
  '0x2e1440fa4fa0bfd01a56bca0f5b50913d762a572': {
    address: '0x2e1440fa4fa0bfd01a56bca0f5b50913d762a572',
    allocation: '213000000000',
    FLOOR: '213',
  },
  '0x9dcf96b9e91e5250f0106197d6b396d736ddc680': {
    address: '0x9dcf96b9e91e5250f0106197d6b396d736ddc680',
    allocation: '168000000000',
    FLOOR: '168',
  },
  '0x000000000035b5e5ad9019092c665357240f594e': {
    address: '0x000000000035b5e5ad9019092c665357240f594e',
    allocation: '45000000000',
    FLOOR: '45',
  },
  '0x01ff6318440f7d5553a82294d78262d5f5084eff': {
    address: '0x01ff6318440f7d5553a82294d78262d5f5084eff',
    allocation: '28000000000',
    FLOOR: '25',
    aFLOOR: '3',
  },
  '0xa73d83b26c481baa4f7341a718b016b9120285c8': {
    address: '0xa73d83b26c481baa4f7341a718b016b9120285c8',
    allocation: '20000000000',
    FLOOR: '20',
  },
  '0xf010f628531045ab8b95ba21db636dc956294281': {
    address: '0xf010f628531045ab8b95ba21db636dc956294281',
    allocation: '11000000000',
    FLOOR: '11',
  },
  '0xdb5a879dfcd59f03721da2c897150d171703f62f': {
    address: '0xdb5a879dfcd59f03721da2c897150d171703f62f',
    allocation: '6000000000',
    FLOOR: '6',
  },
  '0xc440604dac90d672838d69b99d17bdb14e55d5b8': {
    address: '0xc440604dac90d672838d69b99d17bdb14e55d5b8',
    allocation: '6000000000',
    FLOOR: '6',
  },
  '0xfd0000000100069ad1670066004306009b487ad7': {
    address: '0xfd0000000100069ad1670066004306009b487ad7',
    allocation: '5000000000',
    FLOOR: '5',
  },
  '0x4f82e73edb06d29ff62c91ec8f5ff06571bdeb29': {
    address: '0x4f82e73edb06d29ff62c91ec8f5ff06571bdeb29',
    allocation: '2000000000',
    FLOOR: '2',
  },
  '0x826e94c204ce1ddc25c6f56ca26004ed68c35302': {
    address: '0x826e94c204ce1ddc25c6f56ca26004ed68c35302',
    allocation: '2000000000',
    FLOOR: '2',
  },
  '0x00000000008c4fb1c916e0c88fd4cc402d935e7d': {
    address: '0x00000000008c4fb1c916e0c88fd4cc402d935e7d',
    allocation: '2000000000',
    FLOOR: '2',
  },
  '0xe37e799d5077682fa0a244d46e5649f71457bd09': {
    address: '0xe37e799d5077682fa0a244d46e5649f71457bd09',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0x000000000005af2ddc1a93a03e9b7014064d3b8d': {
    address: '0x000000000005af2ddc1a93a03e9b7014064d3b8d',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0xe55b6780b55edca52088704fcd5f651dbd83a6a6': {
    address: '0xe55b6780b55edca52088704fcd5f651dbd83a6a6',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0x1111111254eeb25477b68fb85ed929f73a960582': {
    address: '0x1111111254eeb25477b68fb85ed929f73a960582',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0x07bae765074790b76c791834ab873be27493c163': {
    address: '0x07bae765074790b76c791834ab873be27493c163',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0x00000000002d383933aa1609f11d0afa4d5ea90a': {
    address: '0x00000000002d383933aa1609f11d0afa4d5ea90a',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0x96d4f9d8f23eadee78fc6824fc60b8c1ce578443': {
    address: '0x96d4f9d8f23eadee78fc6824fc60b8c1ce578443',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0xa443447fb845f65eed0b91085984cfb46da7012e': {
    address: '0xa443447fb845f65eed0b91085984cfb46da7012e',
    allocation: '1000000004',
    FLOOR: '1',
    gFLOOR: '1',
  },
  '0x0000000000007f150bd6f54c40a34d7c3d5e9f56': {
    address: '0x0000000000007f150bd6f54c40a34d7c3d5e9f56',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0x0000000000d9455cc7eb92d06e00582a982f68fe': {
    address: '0x0000000000d9455cc7eb92d06e00582a982f68fe',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0xe8c060f8052e07423f71d445277c61ac5138a2e5': {
    address: '0xe8c060f8052e07423f71d445277c61ac5138a2e5',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0xd7078d619c99799e68e0b44119d6da1c0367e43a': {
    address: '0xd7078d619c99799e68e0b44119d6da1c0367e43a',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0x2d86499a410a9ac2139833ba8d6942b8a8700a7b': {
    address: '0x2d86499a410a9ac2139833ba8d6942b8a8700a7b',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0xf4b7090a6dca5240c2b41abcb4f5b32443fbb4f8': {
    address: '0xf4b7090a6dca5240c2b41abcb4f5b32443fbb4f8',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0x0000007c68390193776e8b44df3b698d311070b9': {
    address: '0x0000007c68390193776e8b44df3b698d311070b9',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0x01c12063b7b5b783a989a60af9f9f06534307a2d': {
    address: '0x01c12063b7b5b783a989a60af9f9f06534307a2d',
    allocation: '1000000008',
    FLOOR: '1',
    gFLOOR: '2',
  },
  '0x0000000000d41c96294ccdac8612bdfe29c641af': {
    address: '0x0000000000d41c96294ccdac8612bdfe29c641af',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0x49307d775728daf1d4736ab762de0cefd035e323': {
    address: '0x49307d775728daf1d4736ab762de0cefd035e323',
    allocation: '1000000000',
    FLOOR: '1',
  },
  '0x1930388ceb9d2e57cb2d794002c94fa4dd583657': {
    address: '0x1930388ceb9d2e57cb2d794002c94fa4dd583657',
    allocation: '53165654593365046460416',
    gFLOOR: '13358204671699760185344',
  },
  '0xb7cfa556b42dbc20ba67d36aba99f7f885ebd13d': {
    address: '0xb7cfa556b42dbc20ba67d36aba99f7f885ebd13d',
    allocation: '20659307749597002072064',
    gFLOOR: '5190780841607286489088',
  },
  '0x896b94f4f27f12369698c302e2049cae86936bbb': {
    address: '0x896b94f4f27f12369698c302e2049cae86936bbb',
    allocation: '15963398672360576909312',
    gFLOOR: '4010904189035320705024',
  },
  '0xca04e939a0ac0626c4a4299735e353e8dc5ef3ec': {
    address: '0xca04e939a0ac0626c4a4299735e353e8dc5ef3ec',
    allocation: '15894403394122415079424',
    gFLOOR: '3993568691990556573696',
  },
  '0xe9ee83812fa9eff257ab4f5f4bbd222a1d32f191': {
    address: '0xe9ee83812fa9eff257ab4f5f4bbd222a1d32f191',
    allocation: '12360646691379721797632',
    gFLOOR: '3105690123462241681408',
  },
  '0xef3ede96a9ec62046d42c0725c5d994c1fbcf70e': {
    address: '0xef3ede96a9ec62046d42c0725c5d994c1fbcf70e',
    allocation: '5385079190140639772672',
    gFLOOR: '1353034972397145686016',
  },
  '0x6bf97f2534be2242ddb3a29bfb24d498212dcded': {
    address: '0x6bf97f2534be2242ddb3a29bfb24d498212dcded',
    allocation: '4284814185251431514112',
    gFLOOR: '1076586478706389811200',
  },
  '0xd65a064b9d9456c22179700025be68cbfaa82107': {
    address: '0xd65a064b9d9456c22179700025be68cbfaa82107',
    allocation: '4112340786813762797568',
    gFLOOR: '1033251453973307195392',
  },
  '0xe1d71b60642d597e6e3dbf6d0cd106ac3cfa65fa': {
    address: '0xe1d71b60642d597e6e3dbf6d0cd106ac3cfa65fa',
    allocation: '3618692475889262788608',
    gFLOOR: '909219215047553449984',
  },
  '0xb71c7a2827aa66a83413a5397003c5b0d2a2b4a5': {
    address: '0xb71c7a2827aa66a83413a5397003c5b0d2a2b4a5',
    allocation: '3103664467007871909888',
    gFLOOR: '779815192715545673728',
  },
  '0x3d7cc6652f6a16a69b30af15171b59d6ec8aea23': {
    address: '0x3d7cc6652f6a16a69b30af15171b59d6ec8aea23',
    allocation: '5018483155839781699584',
    gFLOOR: '644251350259995377664',
    sFLOOR: '2454362781805',
  },
  '0x36b5dc2084f22956703f5b9cd32036a9b56bee46': {
    address: '0x36b5dc2084f22956703f5b9cd32036a9b56bee46',
    allocation: '2038464819188335902720',
    gFLOOR: '512177090248325595136',
  },
  '0xaaac34d30d6938787c653aafb922bc20bfa9c512': {
    address: '0xaaac34d30d6938787c653aafb922bc20bfa9c512',
    allocation: '1602725651263545933824',
    gFLOOR: '402694887252147240960',
  },
  '0xa01255f709599cf00676e874ae598d00d9e0694a': {
    address: '0xa01255f709599cf00676e874ae598d00d9e0694a',
    allocation: '1312851330857575120896',
    gFLOOR: '329862143431551549440',
  },
  '0x2ccb1cb25695af8f4ff38352c2696a0af8297d01': {
    address: '0x2ccb1cb25695af8f4ff38352c2696a0af8297d01',
    allocation: '1116717914496459997184',
    gFLOOR: '280582390576999989248',
  },
  '0xe8ec5cee980d00974cb6e1ec4ba03896ae9a4fd2': {
    address: '0xe8ec5cee980d00974cb6e1ec4ba03896ae9a4fd2',
    allocation: '1062134231404652003328',
    gFLOOR: '266867897337852264448',
  },
  '0xbca56f7aa8342650f0068ffe91df19eb43052ce6': {
    address: '0xbca56f7aa8342650f0068ffe91df19eb43052ce6',
    allocation: '1159863353217819475968',
    gFLOOR: '256712175036889333760',
    sFLOOR: '138148896571',
  },
  '0x1813f9ccbb98a8cc8a541a12c8682332d16b5636': {
    address: '0x1813f9ccbb98a8cc8a541a12c8682332d16b5636',
    allocation: '923683515394392981504',
    gFLOOR: '232081285274973110272',
  },
  '0xa0bb038a8981fc526fecf3fcea8701312d932e86': {
    address: '0xa0bb038a8981fc526fecf3fcea8701312d932e86',
    allocation: '834807191855372435456',
    gFLOOR: '209750550717430267904',
  },
  '0x2e1ee9a92fbec075479df59c105289b01b9b7fa9': {
    address: '0x2e1ee9a92fbec075479df59c105289b01b9b7fa9',
    allocation: '812042669330113495040',
    gFLOOR: '204030821439727009792',
  },
  '0xb667c37c063f9ba439c87147c7aeeacc00709f5a': {
    address: '0xb667c37c063f9ba439c87147c7aeeacc00709f5a',
    allocation: '806419160726573023232',
    gFLOOR: '202617879579540946944',
  },
  '0xeffcbe1768341a773d65b26ea804cd1b0aac1e3a': {
    address: '0xeffcbe1768341a773d65b26ea804cd1b0aac1e3a',
    allocation: '673547553168928276480',
    gFLOOR: '169233053560032231424',
  },
  '0x95504dc0e3cf5d6f33eb84a1fe2f1cf1220a1385': {
    address: '0x95504dc0e3cf5d6f33eb84a1fe2f1cf1220a1385',
    allocation: '613972084077501087744',
    gFLOOR: '154264342733040484352',
  },
  '0xdeb08d04004ea00bb6898d19267f7d3399e2827d': {
    address: '0xdeb08d04004ea00bb6898d19267f7d3399e2827d',
    allocation: '599060279211941560320',
    gFLOOR: '150517658093452656640',
  },
  '0xf14afa6a2960a3e79a9a1d617405907f67a7f9d4': {
    address: '0xf14afa6a2960a3e79a9a1d617405907f67a7f9d4',
    allocation: '497608473568478822400',
    gFLOOR: '125027254665446948864',
  },
  '0x10e73b053ed529b6a002d31721501c49a62ef426': {
    address: '0x10e73b053ed529b6a002d31721501c49a62ef426',
    allocation: '487281227560678719488',
    gFLOOR: '122432469236351434752',
  },
  '0x0ef66bff2ca4d4d5dafc137ff9e1a519c2246083': {
    address: '0x0ef66bff2ca4d4d5dafc137ff9e1a519c2246083',
    allocation: '409723733092707729408',
    gFLOOR: '102945661581082345472',
  },
  '0x17e33637f6b64e9082ea499481b6e6ebae7eea23': {
    address: '0x17e33637f6b64e9082ea499481b6e6ebae7eea23',
    allocation: '398000000000000000000',
    gFLOOR: '100000000000000000000',
  },
  '0xf0cb943e5b2d2eabafcfae9dd404913fdb11a2d2': {
    address: '0xf0cb943e5b2d2eabafcfae9dd404913fdb11a2d2',
    allocation: '374803611085428031488',
    gFLOOR: '94171761579253268480',
  },
  '0x4291c64ca6524465361912847de6503a4029c88a': {
    address: '0x4291c64ca6524465361912847de6503a4029c88a',
    allocation: '335887256826039042048',
    gFLOOR: '84393783122120359936',
  },
  '0xcf26ae325bd1e4c35bf6983fbdbd6d4158fc9774': {
    address: '0xcf26ae325bd1e4c35bf6983fbdbd6d4158fc9774',
    allocation: '334843139610541424640',
    gFLOOR: '84131442113201356800',
  },
  '0x37f6605b61b4d4e36fede5b344f09f4dd8e0b89d': {
    address: '0x37f6605b61b4d4e36fede5b344f09f4dd8e0b89d',
    allocation: '316540085021593436160',
    gFLOOR: '79532684678792314880',
  },
  '0x87afaa198117496bce792b6a5de3b33ba7cac73f': {
    address: '0x87afaa198117496bce792b6a5de3b33ba7cac73f',
    allocation: '312982060967136264192',
    gFLOOR: '78638708785712627712',
  },
  '0x6af772b6b81fc3c42ec59fe88e1135c350213589': {
    address: '0x6af772b6b81fc3c42ec59fe88e1135c350213589',
    allocation: '262805978643417071616',
    gFLOOR: '66031652925481672704',
  },
  '0x098a673b992ed3ffd03533aa999b54c51b210918': {
    address: '0x098a673b992ed3ffd03533aa999b54c51b210918',
    allocation: '256058930674419073024',
    gFLOOR: '64336414742316351488',
  },
  '0x3f0001acc7ce06e0dce36cd9850703f94cf343ff': {
    address: '0x3f0001acc7ce06e0dce36cd9850703f94cf343ff',
    allocation: '251644008387268804608',
    gFLOOR: '63227137785745932288',
  },
  '0x7ed6de7a04f6ddb291f6cac03d7668fa9fec7940': {
    address: '0x7ed6de7a04f6ddb291f6cac03d7668fa9fec7940',
    allocation: '253527142462604181504',
    gFLOOR: '58289598731810095104',
    sFLOOR: '21534539510',
  },
  '0x286cd2ff7ad1337baa783c345080e5af9bba0b6e': {
    address: '0x286cd2ff7ad1337baa783c345080e5af9bba0b6e',
    allocation: '231552766480439410688',
    gFLOOR: '58179087055386787840',
  },
  '0xd384cc029b537503895fe252f94fba87a05d677e': {
    address: '0xd384cc029b537503895fe252f94fba87a05d677e',
    allocation: '226887885152965197824',
    gFLOOR: '57007006319840501760',
  },
  '0xe3c983f23875786ccf2ac3f1fe4eabd8e78bf38d': {
    address: '0xe3c983f23875786ccf2ac3f1fe4eabd8e78bf38d',
    allocation: '221231705708409421824',
    gFLOOR: '55585855705630507008',
  },
  '0x2bb9f760473cd2695301ab8cf06931d61f0bd4d3': {
    address: '0x2bb9f760473cd2695301ab8cf06931d61f0bd4d3',
    allocation: '213987017553087791104',
    gFLOOR: '53765582299770798080',
  },
  '0xb24770d2bdad572ecd5f1e57e1e458bbb9a43272': {
    address: '0xb24770d2bdad572ecd5f1e57e1e458bbb9a43272',
    allocation: '175498865300326023168',
    gFLOOR: '44095192286514077696',
  },
  '0xf3d9281fa183b74f32b96e1c5244596045f4ede8': {
    address: '0xf3d9281fa183b74f32b96e1c5244596045f4ede8',
    allocation: '168089204229088280576',
    gFLOOR: '42233468399268413440',
  },
  '0xc51e4f7ada44ca984cbbbaf035b8c2f4672b751d': {
    address: '0xc51e4f7ada44ca984cbbbaf035b8c2f4672b751d',
    allocation: '158894960103040385024',
    gFLOOR: '39923356809809141760',
  },
  '0xb0b51e96fca9a0260bbfacd7250066aea8afb2c0': {
    address: '0xb0b51e96fca9a0260bbfacd7250066aea8afb2c0',
    allocation: '144282568762114850816',
    gFLOOR: '36251901699023831040',
  },
  '0xb34860f27167ed8110991e04e3e7177a58c74401': {
    address: '0xb34860f27167ed8110991e04e3e7177a58c74401',
    allocation: '140866382382693990400',
    gFLOOR: '35393563412737183744',
  },
  '0x996290c17c874d989d6e3db7dc0b2ef0a9fb876d': {
    address: '0x996290c17c874d989d6e3db7dc0b2ef0a9fb876d',
    allocation: '135107848778645307392',
    gFLOOR: '33946695673026457600',
  },
  '0x26b4b07e88f3cd461797e8355125c7b2467e1b74': {
    address: '0x26b4b07e88f3cd461797e8355125c7b2467e1b74',
    allocation: '134405728569022496768',
    gFLOOR: '33770283560055902208',
  },
  '0xfcd7121985f005b2628c03979f2d63cc82028e1a': {
    address: '0xfcd7121985f005b2628c03979f2d63cc82028e1a',
    allocation: '131718077382866354176',
    gFLOOR: '33094994317303103488',
  },
  '0x34d7bceaa2b3cfb1de368baa703683edc666d3f1': {
    address: '0x34d7bceaa2b3cfb1de368baa703683edc666d3f1',
    allocation: '128518373568271663104',
    gFLOOR: '32291048635244138496',
  },
  '0x084c2d7cfdb08e59507899fb0fe0554541d713f7': {
    address: '0x084c2d7cfdb08e59507899fb0fe0554541d713f7',
    allocation: '122932968593077370880',
    gFLOOR: '30887680551024463872',
  },
  '0x7d4157ea91695c66709b57c08083e141e7241160': {
    address: '0x7d4157ea91695c66709b57c08083e141e7241160',
    allocation: '108579335986957533184',
    gFLOOR: '27281240197728022528',
  },
  '0x6232d7a6085d0ab8f885292078eeb723064a376b': {
    address: '0x6232d7a6085d0ab8f885292078eeb723064a376b',
    allocation: '96773107697611276288',
    gFLOOR: '24314851180304338944',
  },
  '0x18a689315811bbecee3b791b9b86a6cd94499f23': {
    address: '0x18a689315811bbecee3b791b9b86a6cd94499f23',
    allocation: '95409711803694448640',
    gFLOOR: '23972289397913178112',
  },
  '0x5d18c78f374286d1fa6b1880545bfad714c29273': {
    address: '0x5d18c78f374286d1fa6b1880545bfad714c29273',
    allocation: '89307331889294311424',
    gFLOOR: '22439028112888016896',
  },
  '0x960c423dc86385945f1f74fbaa1792c3032b93a3': {
    address: '0x960c423dc86385945f1f74fbaa1792c3032b93a3',
    allocation: '83580000000000000000',
    gFLOOR: '21000000000000000000',
  },
  '0xb58617f6aee3a3a3b76a0fcf10c186cbef54cc3c': {
    address: '0xb58617f6aee3a3a3b76a0fcf10c186cbef54cc3c',
    allocation: '73506620396183355392',
    gFLOOR: '18469000099543556096',
  },
  '0x8675c1c5e5a480e277cb4589a6bd17545be1e3b8': {
    address: '0x8675c1c5e5a480e277cb4589a6bd17545be1e3b8',
    allocation: '69807503494249398272',
    gFLOOR: '17539573742273718272',
  },
  '0x328809a567b87b6123462c3062e8438bbb75c1c5': {
    address: '0x328809a567b87b6123462c3062e8438bbb75c1c5',
    allocation: '74617761523595755520',
    gFLOOR: '16092056765225064448',
    sFLOOR: '10571375598',
  },
  '0x5af0481e49a96fee3005b745f8058d4a65096d76': {
    address: '0x5af0481e49a96fee3005b745f8058d4a65096d76',
    allocation: '106217960647777222656',
    gFLOOR: '15355322851200305152',
    sFLOOR: '45103775700',
  },
  '0x93f49eb186525c01c4829d5df04e60ad284b9a5f': {
    address: '0x93f49eb186525c01c4829d5df04e60ad284b9a5f',
    allocation: '55786687698817933312',
    gFLOOR: '14016755703220586496',
  },
  '0xe5947738ec0ad9a3b4f754e7a1913a3dd8975006': {
    address: '0xe5947738ec0ad9a3b4f754e7a1913a3dd8975006',
    allocation: '55547709245636681728',
    gFLOOR: '13956710865737859072',
  },
  '0x6d033e0edca8557bf1453d0146e5f595f6607731': {
    address: '0x6d033e0edca8557bf1453d0146e5f595f6607731',
    allocation: '54705009960550129664',
    gFLOOR: '13744977377022646272',
  },
  '0xe5d4924413ae59ae717358526bbe11bb4a5d76b9': {
    address: '0xe5d4924413ae59ae717358526bbe11bb4a5d76b9',
    allocation: '53981637127045201920',
    gFLOOR: '13563225408805326848',
  },
  '0xd5c33ab19122cea42cb0e99da8b4932859d26784': {
    address: '0xd5c33ab19122cea42cb0e99da8b4932859d26784',
    allocation: '51221554766214578176',
    gFLOOR: '12869737378445873152',
  },
  '0x5991439683ee08cef7861aade8979d6de61690c1': {
    address: '0x5991439683ee08cef7861aade8979d6de61690c1',
    allocation: '48084022804247732224',
    gFLOOR: '12081412764886364160',
  },
  '0x538d1479bfbdb969500e5e8e2d54e47b7527b800': {
    address: '0x538d1479bfbdb969500e5e8e2d54e47b7527b800',
    allocation: '44974000000000000000',
    gFLOOR: '11300000000000000000',
  },
  '0x4d47906ae899a66d2c9ece61a362b244e0d2d061': {
    address: '0x4d47906ae899a66d2c9ece61a362b244e0d2d061',
    allocation: '44974000000000000000',
    gFLOOR: '11300000000000000000',
  },
  '0xd9adc9cca22b991fb54e8b9e06a614476fe1c91b': {
    address: '0xd9adc9cca22b991fb54e8b9e06a614476fe1c91b',
    allocation: '44974000000000000000',
    gFLOOR: '11300000000000000000',
  },
  '0x7827b2ce869af8d192985718674419c2c21bf850': {
    address: '0x7827b2ce869af8d192985718674419c2c21bf850',
    allocation: '44974000000000000000',
    gFLOOR: '11300000000000000000',
  },
  '0x12be6e0a9bcc22ec24a94c857963f4d439008217': {
    address: '0x12be6e0a9bcc22ec24a94c857963f4d439008217',
    allocation: '44974000000000000000',
    gFLOOR: '11300000000000000000',
  },
  '0x4b4a8c0c123514cd7fb29b605229f9f2bb7fca08': {
    address: '0x4b4a8c0c123514cd7fb29b605229f9f2bb7fca08',
    allocation: '44974000000000000000',
    gFLOOR: '11300000000000000000',
  },
  '0xa1fab19678f3be50d6ea3efc533e1c78465ecc33': {
    address: '0xa1fab19678f3be50d6ea3efc533e1c78465ecc33',
    allocation: '44974000000000000000',
    gFLOOR: '11300000000000000000',
  },
  '0x2173487445eeaa078087f0b4965a0c16713c1274': {
    address: '0x2173487445eeaa078087f0b4965a0c16713c1274',
    allocation: '44746942158390312960',
    gFLOOR: '11242950291052843008',
  },
  '0xb03f5438f9a243de5c3b830b7841ec315034cd5f': {
    address: '0xb03f5438f9a243de5c3b830b7841ec315034cd5f',
    allocation: '44350970129485692928',
    gFLOOR: '11143459831529068544',
  },
  '0xd1720e80f9820a1e980e5f5f1b644cde257b6bf0': {
    address: '0xd1720e80f9820a1e980e5f5f1b644cde257b6bf0',
    allocation: '44158368480737640448',
    gFLOOR: '11095067457471768576',
  },
  '0x5aa498511dcdaf36a85833a6e2384dc93720e5f1': {
    address: '0x5aa498511dcdaf36a85833a6e2384dc93720e5f1',
    allocation: '41370700552665612288',
    gFLOOR: '10394648380066736128',
  },
  '0x41d2a18e1ddacdabfddadb62e9aee67c63070b76': {
    address: '0x41d2a18e1ddacdabfddadb62e9aee67c63070b76',
    allocation: '39800000000000000000',
    gFLOOR: '10000000000000000000',
  },
  '0x0b2dfd4b6959d1fda099809b18d5fb298c3012f5': {
    address: '0x0b2dfd4b6959d1fda099809b18d5fb298c3012f5',
    allocation: '39379947953563484160',
    gFLOOR: '9894459284814946304',
  },
  '0x61b4468832a1a78876e5c6f1797b2da9360c73d5': {
    address: '0x61b4468832a1a78876e5c6f1797b2da9360c73d5',
    allocation: '35639822747473473536',
    gFLOOR: '8954729333536049152',
  },
  '0xf1a7b8b3d6a69c30883b2a3fb023593d9bb4c81e': {
    address: '0xf1a7b8b3d6a69c30883b2a3fb023593d9bb4c81e',
    allocation: '34719491296552501248',
    gFLOOR: '8723490275515704320',
  },
  '0x0a0949ad4ebdbaf6434c66761fd32235a6ca76a7': {
    address: '0x0a0949ad4ebdbaf6434c66761fd32235a6ca76a7',
    allocation: '34282112107076227072',
    gFLOOR: '8613596006803072000',
  },
  '0x96e1c99540fa694d1b21302bfce2115a33ae92f8': {
    address: '0x96e1c99540fa694d1b21302bfce2115a33ae92f8',
    allocation: '31426299188297322496',
    gFLOOR: '7896055072436512768',
  },
  '0xe3dff97e14f3a55228ed2f614114bf6b27a7677b': {
    address: '0xe3dff97e14f3a55228ed2f614114bf6b27a7677b',
    allocation: '29027316061136551936',
    gFLOOR: '7293295492747877376',
  },
  '0x0fac5c6bba6cfe88d7c6224dbde2b96be27aecc8': {
    address: '0x0fac5c6bba6cfe88d7c6224dbde2b96be27aecc8',
    allocation: '27001462384052846592',
    gFLOOR: '6784287031169056768',
  },
  '0x08a91763c53c528fe1e453d3e4503f3ddef3714a': {
    address: '0x08a91763c53c528fe1e453d3e4503f3ddef3714a',
    allocation: '26297141790476394496',
    gFLOOR: '6607322057908641792',
  },
  '0x4e0ee3aac591c294da0efa3d21dc0aff1fd8242b': {
    address: '0x4e0ee3aac591c294da0efa3d21dc0aff1fd8242b',
    allocation: '25412378710417068032',
    gFLOOR: '6385019776486700032',
  },
  '0xb68babf19df3889f5185576f7f657c9272923002': {
    address: '0xb68babf19df3889f5185576f7f657c9272923002',
    allocation: '26345649401245249536',
    gFLOOR: '6060967186242525184',
    sFLOOR: '2223000000',
  },
  '0xb6321c5e3d0a97b8d4218bc15ec95bd8d1f7d639': {
    address: '0xb6321c5e3d0a97b8d4218bc15ec95bd8d1f7d639',
    allocation: '23297269275615191040',
    gFLOOR: '5853585245129445376',
  },
  '0x6365c560b3fc40fcaaf709ff35f42b2acb910640': {
    address: '0x6365c560b3fc40fcaaf709ff35f42b2acb910640',
    allocation: '18399557355941666816',
    gFLOOR: '4623004360789363712',
  },
  '0x12f3fbd3473d7d9c55e8bd810e30cb5db7d59cbc': {
    address: '0x12f3fbd3473d7d9c55e8bd810e30cb5db7d59cbc',
    allocation: '18331521706872092672',
    gFLOOR: '4605909976601028096',
  },
  '0xcadabaf8a1e906f41f72ae6f764ac5f82c805f2c': {
    address: '0xcadabaf8a1e906f41f72ae6f764ac5f82c805f2c',
    allocation: '17715253611138942976',
    gFLOOR: '4451068746517322240',
  },
  '0xd754c745a94c6974426c16a99c505b9182232d01': {
    address: '0xd754c745a94c6974426c16a99c505b9182232d01',
    allocation: '44505495842319998976',
    gFLOOR: '4310299984000000000',
    sFLOOR: '27350501906',
  },
  '0x3bdc18acd54a381ddcb252f294e3f92be6f54816': {
    address: '0x3bdc18acd54a381ddcb252f294e3f92be6f54816',
    allocation: '17145385716922466304',
    gFLOOR: '4307885858523232768',
  },
  '0xbfc9eda7bebf60e946dfe52004c4e6e85d713207': {
    address: '0xbfc9eda7bebf60e946dfe52004c4e6e85d713207',
    allocation: '15731741565602795520',
    gFLOOR: '3952698885829848064',
  },
  '0x660c6e11612cdf5fceb297a84071aff390e13c06': {
    address: '0x660c6e11612cdf5fceb297a84071aff390e13c06',
    allocation: '14542424581050988544',
    gFLOOR: '3653875522877132800',
  },
  '0x9e0eb0c6bb8c34263e146b4c6895a83fefeed3c4': {
    address: '0x9e0eb0c6bb8c34263e146b4c6895a83fefeed3c4',
    allocation: '14372118364185335808',
    gFLOOR: '3611085016126968832',
  },
  '0x613d3a898927c0e31fb16995aaf1c3f302985236': {
    address: '0x613d3a898927c0e31fb16995aaf1c3f302985236',
    allocation: '14358223660050444288',
    gFLOOR: '3607593884434784768',
  },
  '0xdb6958f73aa1cbfbe26eb4c104038594a4602ef6': {
    address: '0xdb6958f73aa1cbfbe26eb4c104038594a4602ef6',
    allocation: '13666699978103842816',
    gFLOOR: '3433844215603980800',
  },
  '0x8af98190bcf6bb3dbc769fc72e13eb34ddf8d72c': {
    address: '0x8af98190bcf6bb3dbc769fc72e13eb34ddf8d72c',
    allocation: '13270779421108758528',
    gFLOOR: '3334366688720793600',
  },
  '0xcb387bb731bc2b33bc993958dc522a94e04f540d': {
    address: '0xcb387bb731bc2b33bc993958dc522a94e04f540d',
    allocation: '17360861379904319488',
    gFLOOR: '3286926632388019712',
    sFLOOR: '4278893383',
  },
  '0x62f92494bd7131243bc44109182237f0b00225ee': {
    address: '0x62f92494bd7131243bc44109182237f0b00225ee',
    allocation: '11073060903710851072',
    gFLOOR: '2782176106460013056',
  },
  '0xc1cf4d32821c2b349b810e418dd20f9509d0fc52': {
    address: '0xc1cf4d32821c2b349b810e418dd20f9509d0fc52',
    allocation: '10843782106014711808',
    gFLOOR: '2724568368345404928',
  },
  '0xc6578cc686d93adae0ccaadb0a9190e9e2a9fa13': {
    address: '0xc6578cc686d93adae0ccaadb0a9190e9e2a9fa13',
    allocation: '10809387379751456768',
    gFLOOR: '2715926477324486656',
  },
  '0x22dd68e46d6aa1cbdcd826f82a6aac0bea3f2870': {
    address: '0x22dd68e46d6aa1cbdcd826f82a6aac0bea3f2870',
    allocation: '10095754777921376256',
    gFLOOR: '2536621803497833472',
  },
  '0xf63be97ff407e614f9db7e7ecf8ce1b087b5f644': {
    address: '0xf63be97ff407e614f9db7e7ecf8ce1b087b5f644',
    allocation: '8491399829496040448',
    gFLOOR: '2133517545099507712',
  },
  '0x9367c167d5663e28bb60c1eeb93f7aab6ca63aea': {
    address: '0x9367c167d5663e28bb60c1eeb93f7aab6ca63aea',
    allocation: '7113878904800000000',
    gFLOOR: '1787406760000000000',
  },
  '0x0aefb4f40437cb144307fa5736e3db25cde21ba5': {
    address: '0x0aefb4f40437cb144307fa5736e3db25cde21ba5',
    allocation: '6217307827392281600',
    gFLOOR: '1562137645073437696',
  },
  '0x6b072c94e89081ac214793720470e79ae5ceacee': {
    address: '0x6b072c94e89081ac214793720470e79ae5ceacee',
    allocation: '6217126266260573184',
    gFLOOR: '1562092026698636544',
  },
  '0xf44e3486fbf5dd567e940460d6b59915f97d6904': {
    address: '0xf44e3486fbf5dd567e940460d6b59915f97d6904',
    allocation: '5917595376431078400',
    gFLOOR: '1486833009153537280',
  },
  '0xe29b2159e8df65a94a7b20439070a67939dd917f': {
    address: '0xe29b2159e8df65a94a7b20439070a67939dd917f',
    allocation: '5392572786484965376',
    gFLOOR: '1354917785548986368',
  },
  '0x06b84448a572d6216cdcf5e2eba108693d1506b0': {
    address: '0x06b84448a572d6216cdcf5e2eba108693d1506b0',
    allocation: '4385755313285076992',
    gFLOOR: '1101948571177155072',
  },
  '0xc866b23312b2a14fd5687c184bea44ae69d735e1': {
    address: '0xc866b23312b2a14fd5687c184bea44ae69d735e1',
    allocation: '3980000000000000000',
    gFLOOR: '1000000000000000000',
  },
  '0xdeedb18a5a08a6d3622a2fca03c09afb5719280b': {
    address: '0xdeedb18a5a08a6d3622a2fca03c09afb5719280b',
    allocation: '3980000000000000000',
    gFLOOR: '1000000000000000000',
  },
  '0xef2e060e1569816b37bb923a911ec952b8694f42': {
    address: '0xef2e060e1569816b37bb923a911ec952b8694f42',
    allocation: '3980000000000000000',
    gFLOOR: '1000000000000000000',
  },
  '0x7cd4854339e35fa0243792685baebce73d6a23d1': {
    address: '0x7cd4854339e35fa0243792685baebce73d6a23d1',
    allocation: '3980000000000000000',
    gFLOOR: '1000000000000000000',
  },
  '0xc7a669d0de21f1885361e95fde3892534807b927': {
    address: '0xc7a669d0de21f1885361e95fde3892534807b927',
    allocation: '3980000000000000000',
    gFLOOR: '1000000000000000000',
  },
  '0xf7aa4f39e312a1790c60ddf188a92090b6d5d2e9': {
    address: '0xf7aa4f39e312a1790c60ddf188a92090b6d5d2e9',
    allocation: '3980000000000000000',
    gFLOOR: '1000000000000000000',
  },
  '0x487104caaf1e298ddbc9f2b27453c6ad133e537d': {
    address: '0x487104caaf1e298ddbc9f2b27453c6ad133e537d',
    allocation: '3980000000000000000',
    gFLOOR: '1000000000000000000',
  },
  '0x93f0c941da115cff5680f83172248e7644f5369e': {
    address: '0x93f0c941da115cff5680f83172248e7644f5369e',
    allocation: '3980000000000000000',
    gFLOOR: '1000000000000000000',
  },
  '0xa53a6fe2d8ad977ad926c485343ba39f32d3a3f6': {
    address: '0xa53a6fe2d8ad977ad926c485343ba39f32d3a3f6',
    allocation: '3980000000000000000',
    gFLOOR: '1000000000000000000',
  },
  '0x2dfb5dc942280be73315cbab54b099c2541a0482': {
    address: '0x2dfb5dc942280be73315cbab54b099c2541a0482',
    allocation: '3980000000000000000',
    gFLOOR: '1000000000000000000',
  },
  '0xa8095b86474d53dca0e0bcb1452a4da73090a205': {
    address: '0xa8095b86474d53dca0e0bcb1452a4da73090a205',
    allocation: '3980000000000000000',
    gFLOOR: '1000000000000000000',
  },
  '0x723549b747429dad1016dd8ebaf800580da5ad0c': {
    address: '0x723549b747429dad1016dd8ebaf800580da5ad0c',
    allocation: '3204197325157430784',
    gFLOOR: '805074704813424768',
  },
  '0x3add7e0c58e81a54af0a8f0b592ec7551933fafd': {
    address: '0x3add7e0c58e81a54af0a8f0b592ec7551933fafd',
    allocation: '3127475904764139520',
    gFLOOR: '785797966021140608',
  },
  '0x9ec092c6f3893d430d57dc08dab48fdb8ba1fd22': {
    address: '0x9ec092c6f3893d430d57dc08dab48fdb8ba1fd22',
    allocation: '2875586375818989056',
    gFLOOR: '722509139653012352',
  },
  '0x856dc4a12f08afa49f42b52f81769a96505f312c': {
    address: '0x856dc4a12f08afa49f42b52f81769a96505f312c',
    allocation: '632032191526453760',
    gFLOOR: '158802058172475808',
  },
  '0x5aa6fc97730d43a3517dd9d0ad9783e6aeb33677': {
    address: '0x5aa6fc97730d43a3517dd9d0ad9783e6aeb33677',
    allocation: '554421904202103521280',
    gFLOOR: '98005503292335344',
    sFLOOR: '554031842299',
  },
  '0xf6f4b3d80884dcf2e602820622cafc1bcc1f9afe': {
    address: '0xf6f4b3d80884dcf2e602820622cafc1bcc1f9afe',
    allocation: '276826522592771296',
    gFLOOR: '69554402661500328',
  },
  '0x53f9724f47e0a017c031710a099243f20520e185': {
    address: '0x53f9724f47e0a017c031710a099243f20520e185',
    allocation: '254531134055322752',
    gFLOOR: '63952546245055968',
  },
  '0x1a78b60149abe2548830483a1343e9aac7c13780': {
    address: '0x1a78b60149abe2548830483a1343e9aac7c13780',
    allocation: '40475458119886720',
    gFLOOR: '8704641487408724',
    sFLOOR: '5830985',
  },
  '0x47ec58d5704082527a90362a6293029d7ed5fc4e': {
    address: '0x47ec58d5704082527a90362a6293029d7ed5fc4e',
    allocation: '5425211463429872',
    gFLOOR: '1363118458148209',
  },
  '0x14562ec74c14d779bfdeff4aeea1d24a18566248': {
    address: '0x14562ec74c14d779bfdeff4aeea1d24a18566248',
    allocation: '1248061073391408',
    gFLOOR: '313583184269198',
  },
  '0x356b079be44c5cfa196b366590c8fe7247f96e8f': {
    address: '0x356b079be44c5cfa196b366590c8fe7247f96e8f',
    allocation: '8111481467496999944192',
    sFLOOR: '8111481467497',
  },
  '0xc9706f1ddd4d3e2a9f851da80ecce27577724e44': {
    address: '0xc9706f1ddd4d3e2a9f851da80ecce27577724e44',
    allocation: '3948848288074999791616',
    sFLOOR: '3948848288075',
  },
  '0x16bac908761763b3963b05cbc6bc4bf4efc7ac99': {
    address: '0x16bac908761763b3963b05cbc6bc4bf4efc7ac99',
    allocation: '1342678461160999878656',
    sFLOOR: '1342678461161',
  },
  '0xbdfa4f4492dd7b7cf211209c4791af8d52bf5c50': {
    address: '0xbdfa4f4492dd7b7cf211209c4791af8d52bf5c50',
    allocation: '1222249004004999954432',
    sFLOOR: '1222249004005',
  },
  '0xa87ce3b8e09610f49cd0e2259efe0c11de5380e2': {
    address: '0xa87ce3b8e09610f49cd0e2259efe0c11de5380e2',
    allocation: '1011521387327999967232',
    sFLOOR: '1011521387328',
  },
  '0xeb549edf318fcbbed23cb3dd2323449e401ebd3c': {
    address: '0xeb549edf318fcbbed23cb3dd2323449e401ebd3c',
    allocation: '831291061283999973376',
    sFLOOR: '831291061284',
  },
  '0xf71d161fdc3895f21612d79f15aa819b7a3d296a': {
    address: '0xf71d161fdc3895f21612d79f15aa819b7a3d296a',
    allocation: '792351077806000046080',
    sFLOOR: '792351077806',
  },
  '0x1fbb99bf7e6e8920fac8ab371ceb5a90e0801656': {
    address: '0x1fbb99bf7e6e8920fac8ab371ceb5a90e0801656',
    allocation: '564049415505000005632',
    sFLOOR: '564049415505',
  },
  '0x2d04a2d87b03441d92b944fc093a12d5710eec8e': {
    address: '0x2d04a2d87b03441d92b944fc093a12d5710eec8e',
    allocation: '525154656110000013312',
    sFLOOR: '525154656110',
  },
  '0x9a56d755b9a5529f741657795f3c080647127ee5': {
    address: '0x9a56d755b9a5529f741657795f3c080647127ee5',
    allocation: '497632794824000012288',
    sFLOOR: '497632794824',
  },
  '0x4b1d71c7482bc03efd7d1ddd9f25beea2e376c91': {
    address: '0x4b1d71c7482bc03efd7d1ddd9f25beea2e376c91',
    allocation: '461983949208000004096',
    sFLOOR: '461983949208',
  },
  '0x5737fb122238aac4b2f19e126e0aa36cefe0ecbd': {
    address: '0x5737fb122238aac4b2f19e126e0aa36cefe0ecbd',
    allocation: '449744979201000013824',
    sFLOOR: '449744979201',
  },
  '0xd3cdcb7f1dc60c0b1b03884ac469aeb8ae53ad1f': {
    address: '0xd3cdcb7f1dc60c0b1b03884ac469aeb8ae53ad1f',
    allocation: '419076659458999975936',
    sFLOOR: '419076659459',
  },
  '0x067a35466de04bbc1fcd79afcb68084da7bc5c0b': {
    address: '0x067a35466de04bbc1fcd79afcb68084da7bc5c0b',
    allocation: '358282885289999990784',
    sFLOOR: '358282885290',
  },
  '0xa0f47744838a4e24e8b68a668728a628049b49f6': {
    address: '0xa0f47744838a4e24e8b68a668728a628049b49f6',
    allocation: '348105173624999968768',
    sFLOOR: '348105173625',
  },
  '0x0b0c4f70f66e1889771588cc933ceac296c505d1': {
    address: '0x0b0c4f70f66e1889771588cc933ceac296c505d1',
    allocation: '333198118312999976960',
    sFLOOR: '333198118313',
  },
  '0x0297c8d39bb7c90bfe03e60ed674d175e843d62b': {
    address: '0x0297c8d39bb7c90bfe03e60ed674d175e843d62b',
    allocation: '316435895043999989760',
    sFLOOR: '316435895044',
  },
  '0x4e65175f05b4140a0747c29cce997cd4bb7190d4': {
    address: '0x4e65175f05b4140a0747c29cce997cd4bb7190d4',
    allocation: '313027807417000001536',
    sFLOOR: '313027807417',
  },
  '0xc58bdf3d06073987983989ebfa1ac8187161fa71': {
    address: '0xc58bdf3d06073987983989ebfa1ac8187161fa71',
    allocation: '310000000000000000000',
    sFLOOR: '310000000000',
  },
  '0xb51aabc8151e6109c845e7835fdac21fec8cd65c': {
    address: '0xb51aabc8151e6109c845e7835fdac21fec8cd65c',
    allocation: '292912418084999987200',
    sFLOOR: '292912418085',
  },
  '0x103693d3f9c57724cd107817da39847da78b7692': {
    address: '0x103693d3f9c57724cd107817da39847da78b7692',
    allocation: '266530950763000004608',
    sFLOOR: '266530950763',
  },
  '0x57db24ceec940249dc19d4f3dfb186f910b99cb5': {
    address: '0x57db24ceec940249dc19d4f3dfb186f910b99cb5',
    allocation: '250000000000000000000',
    sFLOOR: '250000000000',
  },
  '0x768f2a7ccdfde9ebdfd5cea8b635dd590cb3a3f1': {
    address: '0x768f2a7ccdfde9ebdfd5cea8b635dd590cb3a3f1',
    allocation: '241548144560999989248',
    sFLOOR: '241548144561',
  },
  '0x52988b591aff299b83cee12a3f78ee87c2cc4ac1': {
    address: '0x52988b591aff299b83cee12a3f78ee87c2cc4ac1',
    allocation: '232326549042999984128',
    sFLOOR: '232326549043',
  },
  '0x6fff4bc5c2d5ff3a6801af91ec1cd13da5bea84e': {
    address: '0x6fff4bc5c2d5ff3a6801af91ec1cd13da5bea84e',
    allocation: '209374779331000008704',
    sFLOOR: '209374779331',
  },
  '0x5be876ed0a9655133226be302ca6f5503e3da569': {
    address: '0x5be876ed0a9655133226be302ca6f5503e3da569',
    allocation: '200000000000000000000',
    sFLOOR: '200000000000',
  },
  '0xf98093c64aef26118e4352dcb7dae1f0a5ab179d': {
    address: '0xf98093c64aef26118e4352dcb7dae1f0a5ab179d',
    allocation: '180000000000000000000',
    sFLOOR: '180000000000',
  },
  '0x4c956623424394c5dc4fd71f04bb28ee117b496f': {
    address: '0x4c956623424394c5dc4fd71f04bb28ee117b496f',
    allocation: '179856915789000015872',
    sFLOOR: '179856915789',
  },
  '0x5641519cc28def80d631baa28b949f17a6a22ad1': {
    address: '0x5641519cc28def80d631baa28b949f17a6a22ad1',
    allocation: '163903013474000011264',
    sFLOOR: '163903013474',
  },
  '0x92fc58d5b963f59e0e8bd4ed4ef22ebadcebe49a': {
    address: '0x92fc58d5b963f59e0e8bd4ed4ef22ebadcebe49a',
    allocation: '161317162926000013312',
    sFLOOR: '161317162926',
  },
  '0x8100b750a7d572c8fd4ae91a27d2f37fd30ef99c': {
    address: '0x8100b750a7d572c8fd4ae91a27d2f37fd30ef99c',
    allocation: '157116499592000012288',
    sFLOOR: '157116499592',
  },
  '0x53ec2777e7d96ffd825f18e700c132b57fe0cdcf': {
    address: '0x53ec2777e7d96ffd825f18e700c132b57fe0cdcf',
    allocation: '152774822543000010752',
    sFLOOR: '152774822543',
  },
  '0xf248e3a38bbbfa1a20fc6fcccb0a35af3e51d642': {
    address: '0xf248e3a38bbbfa1a20fc6fcccb0a35af3e51d642',
    allocation: '145472753932000002048',
    sFLOOR: '145472753932',
  },
  '0xdbc529316fe45f5ce50528bf2356211051fb0f71': {
    address: '0xdbc529316fe45f5ce50528bf2356211051fb0f71',
    allocation: '133893625925000003584',
    sFLOOR: '133893625925',
  },
  '0x7e5f578d0e4c43ae5c06a19bfb43a539a8908c87': {
    address: '0x7e5f578d0e4c43ae5c06a19bfb43a539a8908c87',
    allocation: '124635278284000002048',
    sFLOOR: '124635278284',
  },
  '0x065175053a66f1867fc7d50d59c64df9883d2c79': {
    address: '0x065175053a66f1867fc7d50d59c64df9883d2c79',
    allocation: '110817710682999996416',
    sFLOOR: '110817710683',
  },
  '0x3a9efa46a461f052d835fa5272220c345cb561d6': {
    address: '0x3a9efa46a461f052d835fa5272220c345cb561d6',
    allocation: '110155114568999993344',
    sFLOOR: '110155114569',
  },
  '0x3401ea5a8d91c5e3944962c0148b08ac4a77f153': {
    address: '0x3401ea5a8d91c5e3944962c0148b08ac4a77f153',
    allocation: '104757532925000007680',
    sFLOOR: '104757532925',
  },
  '0xeed7e1c7c9c68611584e8f6230178ce0a48eef7f': {
    address: '0xeed7e1c7c9c68611584e8f6230178ce0a48eef7f',
    allocation: '100803954468000006144',
    sFLOOR: '100803954468',
  },
  '0xbac42c9b32e574f41b86e20fba0cf479a5a1ca58': {
    address: '0xbac42c9b32e574f41b86e20fba0cf479a5a1ca58',
    allocation: '99309240818000003072',
    sFLOOR: '99309240818',
  },
  '0x3c791094a4e16f724f1629b1c5fd679a905e4a3d': {
    address: '0x3c791094a4e16f724f1629b1c5fd679a905e4a3d',
    allocation: '97556966624000000000',
    sFLOOR: '97556966624',
  },
  '0xdc4559fef3240afb93e7e0de7720d879c025b92f': {
    address: '0xdc4559fef3240afb93e7e0de7720d879c025b92f',
    allocation: '90427737209999998976',
    sFLOOR: '90427737210',
  },
  '0x8c03b2a19f7dcd5d9d2501946f399ac9917c3d09': {
    address: '0x8c03b2a19f7dcd5d9d2501946f399ac9917c3d09',
    allocation: '81670384211000000512',
    sFLOOR: '81670384211',
  },
  '0xf60f773494889f18fc7eabbcd5705334bb7cc6dc': {
    address: '0xf60f773494889f18fc7eabbcd5705334bb7cc6dc',
    allocation: '79646924225999994880',
    sFLOOR: '79646924226',
  },
  '0x91e371c3cd3aa81af27b1602d4d8cf9d81ec5a90': {
    address: '0x91e371c3cd3aa81af27b1602d4d8cf9d81ec5a90',
    allocation: '79058565382000001024',
    sFLOOR: '79058565382',
  },
  '0x1b48f880c2909d48f09c0d9f73da5ab44f4ff7bb': {
    address: '0x1b48f880c2909d48f09c0d9f73da5ab44f4ff7bb',
    allocation: '76321872401000005632',
    sFLOOR: '76321872401',
  },
  '0xe42108b5ae543c7c832a29aed64add46b7f0ff54': {
    address: '0xe42108b5ae543c7c832a29aed64add46b7f0ff54',
    allocation: '75974831645000007680',
    sFLOOR: '75974831645',
  },
  '0x747bc3359cb45d8107ca8664bc2255e7f328754e': {
    address: '0x747bc3359cb45d8107ca8664bc2255e7f328754e',
    allocation: '71877138349999996928',
    sFLOOR: '71877138350',
  },
  '0xa84aa4443a8306278eda307dbc0bc5c5971aea86': {
    address: '0xa84aa4443a8306278eda307dbc0bc5c5971aea86',
    allocation: '70463581827999997952',
    sFLOOR: '70463581828',
  },
  '0x7166c092902a0345d9124d90c7fea75450e3e5b6': {
    address: '0x7166c092902a0345d9124d90c7fea75450e3e5b6',
    allocation: '69410215512000004096',
    sFLOOR: '69410215512',
  },
  '0x322df54705699df34393f6cfa0c4f2556973014f': {
    address: '0x322df54705699df34393f6cfa0c4f2556973014f',
    allocation: '65602819890000003072',
    sFLOOR: '65602819890',
  },
  '0x0b1489dd593ef2d6d1bf701819e4c608245b7e30': {
    address: '0x0b1489dd593ef2d6d1bf701819e4c608245b7e30',
    allocation: '64607145471000002560',
    sFLOOR: '64607145471',
  },
  '0xdc628ef5c37a1ff0d022ebc8cacdbf0653b85ea8': {
    address: '0xdc628ef5c37a1ff0d022ebc8cacdbf0653b85ea8',
    allocation: '60835655362000003072',
    sFLOOR: '60835655362',
  },
  '0x32b466947abbda8be79673d47bcec899933e6827': {
    address: '0x32b466947abbda8be79673d47bcec899933e6827',
    allocation: '60000000000000000000',
    sFLOOR: '60000000000',
  },
  '0xb7866dff7395be22985262b03527b19ddac59484': {
    address: '0xb7866dff7395be22985262b03527b19ddac59484',
    allocation: '60000000000000000000',
    sFLOOR: '60000000000',
  },
  '0x88c1aec94f29ea688148e9f128db580ffd78f482': {
    address: '0x88c1aec94f29ea688148e9f128db580ffd78f482',
    allocation: '56000000000000000000',
    sFLOOR: '56000000000',
  },
  '0x7ac159f266be93e67c24f91caf18a42be711ed12': {
    address: '0x7ac159f266be93e67c24f91caf18a42be711ed12',
    allocation: '53907047004000002048',
    sFLOOR: '53907047004',
  },
  '0xb0407cfed810f8b2407cf740f561a95c782496f6': {
    address: '0xb0407cfed810f8b2407cf740f561a95c782496f6',
    allocation: '50706342115999997952',
    sFLOOR: '50706342116',
  },
  '0x1509ee6dc3f18379acc47ab7d349fc1913d2342c': {
    address: '0x1509ee6dc3f18379acc47ab7d349fc1913d2342c',
    allocation: '50084562150999998464',
    sFLOOR: '50084562151',
  },
  '0xb0553d5d747906fc2941845d4aded306336c2a0f': {
    address: '0xb0553d5d747906fc2941845d4aded306336c2a0f',
    allocation: '48541524898000003072',
    sFLOOR: '48541524898',
  },
  '0xd8b3affa8747b9aea0f60ff97d7797942276fcda': {
    address: '0xd8b3affa8747b9aea0f60ff97d7797942276fcda',
    allocation: '47397693794000003072',
    sFLOOR: '47397693794',
  },
  '0x37e46caefef61d30e680cf754998b4a39e5d8325': {
    address: '0x37e46caefef61d30e680cf754998b4a39e5d8325',
    allocation: '47176562029999996928',
    sFLOOR: '47176562030',
  },
  '0x5aec2bdc0229f858a1aceee89dd545fff61a959a': {
    address: '0x5aec2bdc0229f858a1aceee89dd545fff61a959a',
    allocation: '46083436368999997440',
    sFLOOR: '46083436369',
  },
  '0x65830b30128be78f95411a2b1b715cfc201df0ed': {
    address: '0x65830b30128be78f95411a2b1b715cfc201df0ed',
    allocation: '45268218736999997440',
    sFLOOR: '45268218737',
  },
  '0xfb828b4e401fda6b84abc71856582b5ac255cf40': {
    address: '0xfb828b4e401fda6b84abc71856582b5ac255cf40',
    allocation: '44000000000000000000',
    sFLOOR: '44000000000',
  },
  '0x70b02b2c2f2c0c354f81f8068ee4bec4de4f702c': {
    address: '0x70b02b2c2f2c0c354f81f8068ee4bec4de4f702c',
    allocation: '43247568173999996928',
    sFLOOR: '43247568174',
  },
  '0x1fcf595164fe3ed22156bb886dde66fb0e6a439f': {
    address: '0x1fcf595164fe3ed22156bb886dde66fb0e6a439f',
    allocation: '41897833034999996416',
    sFLOOR: '41897833035',
  },
  '0xbd7bb0140b954427650868009d0b0b65ff7b4480': {
    address: '0xbd7bb0140b954427650868009d0b0b65ff7b4480',
    allocation: '41058590873000001536',
    sFLOOR: '41058590873',
  },
  '0xd2c5a953c82e3d8c1066d100b662f2b69bc47970': {
    address: '0xd2c5a953c82e3d8c1066d100b662f2b69bc47970',
    allocation: '40730192778999996416',
    sFLOOR: '40730192779',
  },
  '0xdb1f74e978b30ea46b4cde13c17d79de7eefc3c1': {
    address: '0xdb1f74e978b30ea46b4cde13c17d79de7eefc3c1',
    allocation: '40000000000000000000',
    sFLOOR: '40000000000',
  },
  '0xb73db2dea24fe3d1d554db275df186a7a84306d5': {
    address: '0xb73db2dea24fe3d1d554db275df186a7a84306d5',
    allocation: '39751078045999996928',
    sFLOOR: '39751078046',
  },
  '0x21e2c1b6d51c84cd2e89104a5f72b81fb5226e6e': {
    address: '0x21e2c1b6d51c84cd2e89104a5f72b81fb5226e6e',
    allocation: '37373289213999996928',
    sFLOOR: '37373289214',
  },
  '0x8fad9c07e4b3357073bf62ef7d091bcff4ef4011': {
    address: '0x8fad9c07e4b3357073bf62ef7d091bcff4ef4011',
    allocation: '36092398326000001024',
    sFLOOR: '36092398326',
  },
  '0x10f24fbc2a4addf445adf143beb5e4236319f50b': {
    address: '0x10f24fbc2a4addf445adf143beb5e4236319f50b',
    allocation: '35181167116000002048',
    sFLOOR: '35181167116',
  },
  '0x52a57ef89e4139542e7a29b6db53464af728e870': {
    address: '0x52a57ef89e4139542e7a29b6db53464af728e870',
    allocation: '34205816800000000000',
    sFLOOR: '34205816800',
  },
  '0xb48d6c33a96f5519c82569b478fcd723b3a94a2a': {
    address: '0xb48d6c33a96f5519c82569b478fcd723b3a94a2a',
    allocation: '33965969801999998976',
    sFLOOR: '33965969802',
  },
  '0x59e69d7988d98cd5255966b6419d927bebafc578': {
    address: '0x59e69d7988d98cd5255966b6419d927bebafc578',
    allocation: '31132540785000001536',
    sFLOOR: '31132540785',
  },
  '0x8b4a890de6f74ec226b68b958111248da8e47399': {
    address: '0x8b4a890de6f74ec226b68b958111248da8e47399',
    allocation: '30819959156999999488',
    sFLOOR: '30819959157',
  },
  '0x4acf5fcd324390f050a817edd41cf1d60edbb384': {
    address: '0x4acf5fcd324390f050a817edd41cf1d60edbb384',
    allocation: '30000000000000000000',
    sFLOOR: '30000000000',
  },
  '0x6ebbd2f1ce30b0b9e61ae35344255a80fdfa9e5e': {
    address: '0x6ebbd2f1ce30b0b9e61ae35344255a80fdfa9e5e',
    allocation: '27032095190999998464',
    sFLOOR: '27032095191',
  },
  '0x36b56d31fa0a8431ff2caabe29dd9c4df712499c': {
    address: '0x36b56d31fa0a8431ff2caabe29dd9c4df712499c',
    allocation: '26061068625000001536',
    sFLOOR: '26061068625',
  },
  '0xdabb14edd4555d0b4baef125ee59150c2f50c426': {
    address: '0xdabb14edd4555d0b4baef125ee59150c2f50c426',
    allocation: '25664247315999997952',
    sFLOOR: '25664247316',
  },
  '0x3839acf1ee7699d1f46b1be840d8ad8317fdf757': {
    address: '0x3839acf1ee7699d1f46b1be840d8ad8317fdf757',
    allocation: '25000000000000000000',
    sFLOOR: '25000000000',
  },
  '0x4e3d9399c28c724293dd545225ec843ac4c9e953': {
    address: '0x4e3d9399c28c724293dd545225ec843ac4c9e953',
    allocation: '24589352249999998976',
    sFLOOR: '24589352250',
  },
  '0xf255fcdab4f3ee3f9f602c9656dba6697c9fe67a': {
    address: '0xf255fcdab4f3ee3f9f602c9656dba6697c9fe67a',
    allocation: '23727261827000000512',
    sFLOOR: '23727261827',
  },
  '0xc057474be99cdd42e75ce8ad11a4f86bc4e1218a': {
    address: '0xc057474be99cdd42e75ce8ad11a4f86bc4e1218a',
    allocation: '23645315761000001536',
    sFLOOR: '23645315761',
  },
  '0xadaf500b965545c8a766cd9cdeb3bf3fbef073e5': {
    address: '0xadaf500b965545c8a766cd9cdeb3bf3fbef073e5',
    allocation: '22042712120000000000',
    sFLOOR: '22042712120',
  },
  '0xbdca4901babfb1bf88b092abef77278d68a4d86b': {
    address: '0xbdca4901babfb1bf88b092abef77278d68a4d86b',
    allocation: '21229028131999997952',
    sFLOOR: '21229028132',
  },
  '0xda6657c01ac8cfb42acd58674684738f2d0eb42f': {
    address: '0xda6657c01ac8cfb42acd58674684738f2d0eb42f',
    allocation: '20107853412999999488',
    sFLOOR: '20107853413',
  },
  '0x43b057ba8e3f5419c08cc1b0717711acf59e4e21': {
    address: '0x43b057ba8e3f5419c08cc1b0717711acf59e4e21',
    allocation: '19729849636999999488',
    sFLOOR: '19729849637',
  },
  '0x81d98c8fda0410ee3e9d7586cb949cd19fa4cf38': {
    address: '0x81d98c8fda0410ee3e9d7586cb949cd19fa4cf38',
    allocation: '19535020145999998976',
    sFLOOR: '19535020146',
  },
  '0xcb9cc4fe93c053f283aee88b86d84cd48e514cbc': {
    address: '0xcb9cc4fe93c053f283aee88b86d84cd48e514cbc',
    allocation: '19457547684999999488',
    sFLOOR: '19457547685',
  },
  '0x45385e776d96ef483efe321a5154653d1d2f3f7f': {
    address: '0x45385e776d96ef483efe321a5154653d1d2f3f7f',
    allocation: '18784209126000001024',
    sFLOOR: '18784209126',
  },
  '0xf56e8123d34df6a071a005c31852af57a8cbae1b': {
    address: '0xf56e8123d34df6a071a005c31852af57a8cbae1b',
    allocation: '18261529836000000000',
    sFLOOR: '18261529836',
  },
  '0x5c6ce6ccf6d9fc425fc0d5de49c36e270cbdd667': {
    address: '0x5c6ce6ccf6d9fc425fc0d5de49c36e270cbdd667',
    allocation: '17653698668999999488',
    sFLOOR: '17653698669',
  },
  '0xf980a7d740cade592f68295cb0872022a326c315': {
    address: '0xf980a7d740cade592f68295cb0872022a326c315',
    allocation: '17059010457999998976',
    sFLOOR: '17059010458',
  },
  '0x112acb1c384a26c015043adb4f25495f96f3918b': {
    address: '0x112acb1c384a26c015043adb4f25495f96f3918b',
    allocation: '17005210689999998976',
    sFLOOR: '17005210690',
  },
  '0xc0b54d21ccdc5bfabbe08885aaa8041d4db24a5b': {
    address: '0xc0b54d21ccdc5bfabbe08885aaa8041d4db24a5b',
    allocation: '16803661716999999488',
    sFLOOR: '16803661717',
  },
  '0x2821f23bf8650664980f46b1c0858ac7fe66de05': {
    address: '0x2821f23bf8650664980f46b1c0858ac7fe66de05',
    allocation: '16641264876999999488',
    sFLOOR: '16641264877',
  },
  '0x604b034da608c682b12a577392a7f3d3f8c9176d': {
    address: '0x604b034da608c682b12a577392a7f3d3f8c9176d',
    allocation: '15887277745999998976',
    sFLOOR: '15887277746',
  },
  '0x89b193703b1323c17cb58cfc8e0dcc06e92face1': {
    address: '0x89b193703b1323c17cb58cfc8e0dcc06e92face1',
    allocation: '15762907847000000512',
    sFLOOR: '15762907847',
  },
  '0x8d0cf15d459b98fcc84a56d86737f44ff2204751': {
    address: '0x8d0cf15d459b98fcc84a56d86737f44ff2204751',
    allocation: '14506561486000001024',
    sFLOOR: '14506561486',
  },
  '0x453d2c7d86ae150c18f5486586040f1770059e7d': {
    address: '0x453d2c7d86ae150c18f5486586040f1770059e7d',
    allocation: '14456072168999999488',
    sFLOOR: '14456072169',
  },
  '0x470229279a82f5c4a55a46b6c9c9394b05e240f4': {
    address: '0x470229279a82f5c4a55a46b6c9c9394b05e240f4',
    allocation: '13662156716999999488',
    sFLOOR: '13662156717',
  },
  '0x2a77543e0134869bbd0cb989aa07ada85134f92f': {
    address: '0x2a77543e0134869bbd0cb989aa07ada85134f92f',
    allocation: '13604587120999999488',
    sFLOOR: '13604587121',
  },
  '0xf3db3e79cd7dd756d4babac4b7d64003fe4b33fa': {
    address: '0xf3db3e79cd7dd756d4babac4b7d64003fe4b33fa',
    allocation: '12851854760000000000',
    sFLOOR: '12851854760',
  },
  '0x256530ce969f76ece1cf66998aef0eab6a940fa8': {
    address: '0x256530ce969f76ece1cf66998aef0eab6a940fa8',
    allocation: '12404838452000000000',
    sFLOOR: '12404838452',
  },
  '0xd1838c8d2338717aca9d8d46e21bab24d90befcc': {
    address: '0xd1838c8d2338717aca9d8d46e21bab24d90befcc',
    allocation: '11378472678000001024',
    sFLOOR: '11378472678',
  },
  '0xd727bc654ac210f1ae2e53ee2e4266f24b316fcd': {
    address: '0xd727bc654ac210f1ae2e53ee2e4266f24b316fcd',
    allocation: '11240504648000000000',
    sFLOOR: '11240504648',
  },
  '0x40f51eb502ac737b4874925feac8c970f9b01f74': {
    address: '0x40f51eb502ac737b4874925feac8c970f9b01f74',
    allocation: '11000000000000000000',
    sFLOOR: '11000000000',
  },
  '0xd5e40697d9e74214cc183be7810f6dcd08b799b3': {
    address: '0xd5e40697d9e74214cc183be7810f6dcd08b799b3',
    allocation: '10991165934000001024',
    sFLOOR: '10991165934',
  },
  '0xb4a619375c951cd98fe1490b3dff047116ce340d': {
    address: '0xb4a619375c951cd98fe1490b3dff047116ce340d',
    allocation: '10495045427000000512',
    sFLOOR: '10495045427',
  },
  '0xc5a1b96bee388bd77fc1ca9d92cf61bea9f4ff2d': {
    address: '0xc5a1b96bee388bd77fc1ca9d92cf61bea9f4ff2d',
    allocation: '10000000000000000000',
    sFLOOR: '10000000000',
  },
  '0x6dd91bdab368282dc4ea4f4befc831b78a7c38c0': {
    address: '0x6dd91bdab368282dc4ea4f4befc831b78a7c38c0',
    allocation: '10000000000000000000',
    sFLOOR: '10000000000',
  },
  '0x50f8d9a555516ea6d6cc3e0fc1f02e1807b605c2': {
    address: '0x50f8d9a555516ea6d6cc3e0fc1f02e1807b605c2',
    allocation: '10000000000000000000',
    sFLOOR: '10000000000',
  },
  '0xaa95b126f7c6d0fb5ca3cc8cd2782ffa3c52c0c8': {
    address: '0xaa95b126f7c6d0fb5ca3cc8cd2782ffa3c52c0c8',
    allocation: '9860397492999999488',
    sFLOOR: '9860397493',
  },
  '0x7dbcc676d2a750915e33967dc14974be858ed637': {
    address: '0x7dbcc676d2a750915e33967dc14974be858ed637',
    allocation: '9549733728999999488',
    sFLOOR: '9549733729',
  },
  '0x870dc279570833a8c5a72fc7972681db9a96cfb7': {
    address: '0x870dc279570833a8c5a72fc7972681db9a96cfb7',
    allocation: '9351770528000000000',
    sFLOOR: '9351770528',
  },
  '0x6bf26e56bbcbe3c4ea822ebd3e04a82bfa0f292a': {
    address: '0x6bf26e56bbcbe3c4ea822ebd3e04a82bfa0f292a',
    allocation: '8980325092000000000',
    sFLOOR: '8980325092',
  },
  '0xc1b0307ff325527511310c7d6fd3248188742f86': {
    address: '0xc1b0307ff325527511310c7d6fd3248188742f86',
    allocation: '8556872667000000512',
    sFLOOR: '8556872667',
  },
  '0x55e3f3141de15bf7b431124c81131a3f1a14805c': {
    address: '0x55e3f3141de15bf7b431124c81131a3f1a14805c',
    allocation: '8311008755000000512',
    sFLOOR: '8311008755',
  },
  '0xb56b1dd319634f6072ac5af4bfc60968e0e8a50b': {
    address: '0xb56b1dd319634f6072ac5af4bfc60968e0e8a50b',
    allocation: '8261534728000000000',
    sFLOOR: '8261534728',
  },
  '0xac992da07e0227d9e999e8a149945b3361ba8043': {
    address: '0xac992da07e0227d9e999e8a149945b3361ba8043',
    allocation: '8201548447000000512',
    sFLOOR: '8201548447',
  },
  '0xfe03c7cba3d614cbf4159056ce57afed77329e75': {
    address: '0xfe03c7cba3d614cbf4159056ce57afed77329e75',
    allocation: '8173633327000000512',
    sFLOOR: '8173633327',
  },
  '0x47bcd8e7c6b92efad01a254e7d87875aaf95be4b': {
    address: '0x47bcd8e7c6b92efad01a254e7d87875aaf95be4b',
    allocation: '7682724124000000000',
    sFLOOR: '7682724124',
  },
  '0x87b35090d4f8a4cf0729c9782c5f633df8858bd9': {
    address: '0x87b35090d4f8a4cf0729c9782c5f633df8858bd9',
    allocation: '7547986828999999488',
    sFLOOR: '7547986829',
  },
  '0xd12267099217705b4f41dbd302bcc1ec40fb0dcd': {
    address: '0xd12267099217705b4f41dbd302bcc1ec40fb0dcd',
    allocation: '7420999130000000000',
    sFLOOR: '7420999130',
  },
  '0x260dc3729c579bc82fae361c335516e33c260073': {
    address: '0x260dc3729c579bc82fae361c335516e33c260073',
    allocation: '6007364724999999488',
    sFLOOR: '6007364725',
  },
  '0xebd93a2611b0a35f722e79a4bf7f7f000c514a4d': {
    address: '0xebd93a2611b0a35f722e79a4bf7f7f000c514a4d',
    allocation: '5824350819000000512',
    sFLOOR: '5824350819',
  },
  '0xc42e57b7d1dd89cf25c0e8df0c3df642098f7745': {
    address: '0xc42e57b7d1dd89cf25c0e8df0c3df642098f7745',
    allocation: '5799901127000000512',
    sFLOOR: '5799901127',
  },
  '0xfa2f61069d811fad0f6907db6d2f2ddd4787c4d3': {
    address: '0xfa2f61069d811fad0f6907db6d2f2ddd4787c4d3',
    allocation: '5572822172000000000',
    sFLOOR: '5572822172',
  },
  '0xb173e20b4d43fdc2f9008de354c2154f7e23e291': {
    address: '0xb173e20b4d43fdc2f9008de354c2154f7e23e291',
    allocation: '5111359604000000000',
    sFLOOR: '5111359604',
  },
  '0x5780978198044e47de38570eb68a520bd8cd72c3': {
    address: '0x5780978198044e47de38570eb68a520bd8cd72c3',
    allocation: '5000000000000000000',
    sFLOOR: '5000000000',
  },
  '0x5e81686fd1b575b6cd5e6f200c6997e251b1f997': {
    address: '0x5e81686fd1b575b6cd5e6f200c6997e251b1f997',
    allocation: '4704216036999999488',
    sFLOOR: '4704216037',
  },
  '0x7197e6aba6981c9563039c5ec720847a39e1810d': {
    address: '0x7197e6aba6981c9563039c5ec720847a39e1810d',
    allocation: '4119667929000000000',
    sFLOOR: '4119667929',
  },
  '0xbe67de0c3f7650b958aabdfff3bbd8d55d5c2ccd': {
    address: '0xbe67de0c3f7650b958aabdfff3bbd8d55d5c2ccd',
    allocation: '4010410959000000000',
    sFLOOR: '4010410959',
  },
  '0x0dfc7e0342df4c1323bd022b2a27ef2332e775ea': {
    address: '0x0dfc7e0342df4c1323bd022b2a27ef2332e775ea',
    allocation: '3393129557000000000',
    sFLOOR: '3393129557',
  },
  '0x33a10d22c60d2a72d22f134228715ec28e91d287': {
    address: '0x33a10d22c60d2a72d22f134228715ec28e91d287',
    allocation: '2931245692000000000',
    sFLOOR: '2931245692',
  },
  '0x0d2ac482d6c5cfc89b66f7a45ed84c75647b755a': {
    address: '0x0d2ac482d6c5cfc89b66f7a45ed84c75647b755a',
    allocation: '2864501599000000000',
    sFLOOR: '2864501599',
  },
  '0xb4a59de64487b79c328db49aaf4546b8f884f4c6': {
    address: '0xb4a59de64487b79c328db49aaf4546b8f884f4c6',
    allocation: '2822674944000000000',
    sFLOOR: '2822674944',
  },
  '0x26f6b241f495c68d9b45c336b2f2bf51d1b6ab56': {
    address: '0x26f6b241f495c68d9b45c336b2f2bf51d1b6ab56',
    allocation: '2635712582000000000',
    sFLOOR: '2635712582',
  },
  '0x3979a63548e58185580f8785eb21d8ac387d7c9f': {
    address: '0x3979a63548e58185580f8785eb21d8ac387d7c9f',
    allocation: '2230875954000000000',
    sFLOOR: '2230875954',
  },
  '0x16c1610248133c35b2669d9b557f28f7f407836e': {
    address: '0x16c1610248133c35b2669d9b557f28f7f407836e',
    allocation: '2111374854000000000',
    sFLOOR: '2111374854',
  },
  '0xee884fe6d8955a12a91be2ebe897e2faea76e594': {
    address: '0xee884fe6d8955a12a91be2ebe897e2faea76e594',
    allocation: '2082512783000000000',
    sFLOOR: '2082512783',
  },
  '0xad8771ab5c02c5e7bee612d67aad5f938120e1d5': {
    address: '0xad8771ab5c02c5e7bee612d67aad5f938120e1d5',
    allocation: '2026952230000000000',
    sFLOOR: '2026952230',
  },
  '0xb9cabd1830e0c05663d5173219aa374c2fd880ac': {
    address: '0xb9cabd1830e0c05663d5173219aa374c2fd880ac',
    allocation: '1865112932000000000',
    sFLOOR: '1865112932',
  },
  '0x6f454fa5c8c9dc56209f6f5d4c7df32c735c4946': {
    address: '0x6f454fa5c8c9dc56209f6f5d4c7df32c735c4946',
    allocation: '1739517819000000000',
    sFLOOR: '1739517819',
  },
  '0xc12faf701d05af1cfabdefc770c3b3c7b59eae10': {
    address: '0xc12faf701d05af1cfabdefc770c3b3c7b59eae10',
    allocation: '1715399823000000000',
    sFLOOR: '1715399823',
  },
  '0x722e895a12d2a11be99ed69dbc1fedbb9f3cd8fe': {
    address: '0x722e895a12d2a11be99ed69dbc1fedbb9f3cd8fe',
    allocation: '1453270054000000000',
    sFLOOR: '1453270054',
  },
  '0x87aba2b7e41570e2c510f8e13689b01165015800': {
    address: '0x87aba2b7e41570e2c510f8e13689b01165015800',
    allocation: '1344945518000000000',
    sFLOOR: '1344945518',
  },
  '0x1714433a95761117068ebc83d91b643b6c144c50': {
    address: '0x1714433a95761117068ebc83d91b643b6c144c50',
    allocation: '1285792226000000000',
    sFLOOR: '1285792226',
  },
  '0x9224bbb4e0fbe2f2f8fab55debc41eb21fdfb804': {
    address: '0x9224bbb4e0fbe2f2f8fab55debc41eb21fdfb804',
    allocation: '1120290080000000000',
    sFLOOR: '1120290080',
  },
  '0x9ce374580d16d3d67e8a0e250e91fcdfaf8aa1ff': {
    address: '0x9ce374580d16d3d67e8a0e250e91fcdfaf8aa1ff',
    allocation: '1080018329000000000',
    sFLOOR: '1080018329',
  },
  '0x6d7c9f86d84f9535d68968b4464197bb1af2b9e4': {
    address: '0x6d7c9f86d84f9535d68968b4464197bb1af2b9e4',
    allocation: '1068194135000000000',
    sFLOOR: '1068194135',
  },
  '0x60fe0dd8c11292ec2456eb75289d4eef44333272': {
    address: '0x60fe0dd8c11292ec2456eb75289d4eef44333272',
    allocation: '1000000000000000000',
    sFLOOR: '1000000000',
  },
  '0x04655832bcb0a9a0be8c5ab71e4d311464c97af5': {
    address: '0x04655832bcb0a9a0be8c5ab71e4d311464c97af5',
    allocation: '1000000000000000000',
    sFLOOR: '1000000000',
  },
  '0x7ab700a3b5e1c3ef823c82c7ec8b19d01723fc19': {
    address: '0x7ab700a3b5e1c3ef823c82c7ec8b19d01723fc19',
    allocation: '858711577000000000',
    sFLOOR: '858711577',
  },
  '0x0632f5ddd1ad576e7e6c549d8bc488cdc8a5a4f9': {
    address: '0x0632f5ddd1ad576e7e6c549d8bc488cdc8a5a4f9',
    allocation: '817099733000000000',
    sFLOOR: '817099733',
  },
  '0x11d67fa925877813b744abc0917900c2b1d6eb81': {
    address: '0x11d67fa925877813b744abc0917900c2b1d6eb81',
    allocation: '789578831000000000',
    sFLOOR: '789578831',
  },
  '0x97b9b29552317867368a9f0234dc768fb6a27fd9': {
    address: '0x97b9b29552317867368a9f0234dc768fb6a27fd9',
    allocation: '783273276000000000',
    sFLOOR: '783273276',
  },
  '0x59265c2f1e8cfc6ce4d918da3df3f160d75568ea': {
    address: '0x59265c2f1e8cfc6ce4d918da3df3f160d75568ea',
    allocation: '693408135000000000',
    sFLOOR: '693408135',
  },
  '0x3635364e89ef6e842dd16a4028df0a7124ca7a4a': {
    address: '0x3635364e89ef6e842dd16a4028df0a7124ca7a4a',
    allocation: '680810509000000000',
    sFLOOR: '680810509',
  },
  '0xccf7872841ba2309ffa42eb0d4b55dcdcf32908a': {
    address: '0xccf7872841ba2309ffa42eb0d4b55dcdcf32908a',
    allocation: '661755138000000000',
    sFLOOR: '661755138',
  },
  '0xe8386fae370e5767fda50e81acb3f5726b2aa55d': {
    address: '0xe8386fae370e5767fda50e81acb3f5726b2aa55d',
    allocation: '659437228000000000',
    sFLOOR: '659437228',
  },
  '0x2a149dc9a2d3517029209572c60f1c1c434656a2': {
    address: '0x2a149dc9a2d3517029209572c60f1c1c434656a2',
    allocation: '652631221000000000',
    sFLOOR: '652631221',
  },
  '0x87e4322a9aecfbc8d374462657ae014f9965d627': {
    address: '0x87e4322a9aecfbc8d374462657ae014f9965d627',
    allocation: '632434698000000000',
    sFLOOR: '632434698',
  },
  '0x2acffbbbe9cc4b9d245ff8d83bc65584f99f63a4': {
    address: '0x2acffbbbe9cc4b9d245ff8d83bc65584f99f63a4',
    allocation: '619097346000000000',
    sFLOOR: '619097346',
  },
  '0x7f3e244e9d8fda47db77d7a24e21bfb21894fc38': {
    address: '0x7f3e244e9d8fda47db77d7a24e21bfb21894fc38',
    allocation: '615124783000000000',
    sFLOOR: '615124783',
  },
  '0x5688aadc2c1c989bda1086e1f0a7558ef00c3cbe': {
    address: '0x5688aadc2c1c989bda1086e1f0a7558ef00c3cbe',
    allocation: '578328881000000000',
    sFLOOR: '578328881',
  },
  '0xbca5cad99c22be2264d5d3ab2c06d445545d4468': {
    address: '0xbca5cad99c22be2264d5d3ab2c06d445545d4468',
    allocation: '555928616000000000',
    sFLOOR: '555928616',
  },
  '0x74231623d8058afc0a62f919742e15af0fb299e5': {
    address: '0x74231623d8058afc0a62f919742e15af0fb299e5',
    allocation: '498324988000000000',
    sFLOOR: '498324988',
  },
  '0xb48bf8b39f9d0d5005c9c000f504c128c557775e': {
    address: '0xb48bf8b39f9d0d5005c9c000f504c128c557775e',
    allocation: '359783712000000000',
    sFLOOR: '359783712',
  },
  '0xbc9a9fe486e471f33d68b442e699add34a8d1689': {
    address: '0xbc9a9fe486e471f33d68b442e699add34a8d1689',
    allocation: '349791078000000000',
    sFLOOR: '349791078',
  },
  '0xde79aaa2f54160b45ef69e1c4b8fc4c290cd5b88': {
    address: '0xde79aaa2f54160b45ef69e1c4b8fc4c290cd5b88',
    allocation: '193435406000000000',
    sFLOOR: '193435406',
  },
  '0x85758dd94fd1d99ce6f6b9dc22842c3a80c3c796': {
    address: '0x85758dd94fd1d99ce6f6b9dc22842c3a80c3c796',
    allocation: '187611895000000000',
    sFLOOR: '187611895',
  },
  '0x2cfbe0121e72f5ed6e0b32aed62235b0e59333a6': {
    address: '0x2cfbe0121e72f5ed6e0b32aed62235b0e59333a6',
    allocation: '172777457000000000',
    sFLOOR: '172777457',
  },
  '0x3a4bed67a33ac757088d2e05828306d54eb04958': {
    address: '0x3a4bed67a33ac757088d2e05828306d54eb04958',
    allocation: '165315937000000000',
    sFLOOR: '165315937',
  },
  '0xf9107317b0ff77ed5b7adea15e50514a3564002b': {
    address: '0xf9107317b0ff77ed5b7adea15e50514a3564002b',
    allocation: '154272994000000000',
    sFLOOR: '154272994',
  },
  '0xfb7c04273250248aaa9a6a06ca68cc4d8e23cae2': {
    address: '0xfb7c04273250248aaa9a6a06ca68cc4d8e23cae2',
    allocation: '134417236000000000',
    sFLOOR: '134417236',
  },
  '0x173107421523f1e469372e0529b64eeb49616fca': {
    address: '0x173107421523f1e469372e0529b64eeb49616fca',
    allocation: '120630771000000000',
    sFLOOR: '120630771',
  },
  '0xd0f48a775c21b8ec7fed1761c99aced693a69e89': {
    address: '0xd0f48a775c21b8ec7fed1761c99aced693a69e89',
    allocation: '119252594000000000',
    sFLOOR: '119252594',
  },
  '0x7f434cd5fa5b6e145b3ef25703ae7dcf775e119c': {
    address: '0x7f434cd5fa5b6e145b3ef25703ae7dcf775e119c',
    allocation: '118366831000000000',
    sFLOOR: '118366831',
  },
  '0xff4e7014ff7b18599142e60b5bc302bed5675d9f': {
    address: '0xff4e7014ff7b18599142e60b5bc302bed5675d9f',
    allocation: '118183756000000000',
    sFLOOR: '118183756',
  },
  '0x9fa5f0553864c1789362dce77f4b7e8fa5631953': {
    address: '0x9fa5f0553864c1789362dce77f4b7e8fa5631953',
    allocation: '104953725000000000',
    sFLOOR: '104953725',
  },
  '0x2649bd829e37463b27135d6b11ba75fe0fb24108': {
    address: '0x2649bd829e37463b27135d6b11ba75fe0fb24108',
    allocation: '103322930000000000',
    sFLOOR: '103322930',
  },
  '0x19a99f5b363f2dbb7a35cb0b16f96b3f3ae2c280': {
    address: '0x19a99f5b363f2dbb7a35cb0b16f96b3f3ae2c280',
    allocation: '101509337000000000',
    sFLOOR: '101509337',
  },
  '0x61a8272446a3a30dd826475fb8e94dba89f5064e': {
    address: '0x61a8272446a3a30dd826475fb8e94dba89f5064e',
    allocation: '93566070000000000',
    sFLOOR: '93566070',
  },
  '0xd140e84e6cd4f0136e64441a04abf74098396630': {
    address: '0xd140e84e6cd4f0136e64441a04abf74098396630',
    allocation: '92287415000000000',
    sFLOOR: '92287415',
  },
  '0x590491a10c55f16331a2276801278b4f8d2841d6': {
    address: '0x590491a10c55f16331a2276801278b4f8d2841d6',
    allocation: '78607426000000000',
    sFLOOR: '78607426',
  },
  '0x800498c79cc111f4c04745e0569ff275dfe0ad58': {
    address: '0x800498c79cc111f4c04745e0569ff275dfe0ad58',
    allocation: '77114045000000000',
    sFLOOR: '77114045',
  },
  '0xeeeaa8a15051121420887a2a504cf4e6c7621ce7': {
    address: '0xeeeaa8a15051121420887a2a504cf4e6c7621ce7',
    allocation: '58005649000000000',
    sFLOOR: '58005649',
  },
  '0xfcd2c620012e67a58d096bb888c746d940ed92c7': {
    address: '0xfcd2c620012e67a58d096bb888c746d940ed92c7',
    allocation: '51853835000000000',
    sFLOOR: '51853835',
  },
  '0xd2b101d3a69b20ac140ce233a67dd88abb0222b1': {
    address: '0xd2b101d3a69b20ac140ce233a67dd88abb0222b1',
    allocation: '41536051000000000',
    sFLOOR: '41536051',
  },
  '0xb1b70a8bf2be22229bfea06b76706da77c29bc8b': {
    address: '0xb1b70a8bf2be22229bfea06b76706da77c29bc8b',
    allocation: '27501117000000000',
    sFLOOR: '27501117',
  },
  '0x72cb6f6880bca6b74f52c89579b05fcba48e8eb8': {
    address: '0x72cb6f6880bca6b74f52c89579b05fcba48e8eb8',
    allocation: '12005928000000000',
    sFLOOR: '12005928',
  },
  '0xf58d941964b04d274a30f5b8bc4638b5d035507e': {
    address: '0xf58d941964b04d274a30f5b8bc4638b5d035507e',
    allocation: '5722692000000000',
    sFLOOR: '5722692',
  },
  '0xfb96ddc122d446ec4019799a2e4a71544d9b99ae': {
    address: '0xfb96ddc122d446ec4019799a2e4a71544d9b99ae',
    allocation: '776759000000000',
    sFLOOR: '776759',
  },
  '0xbf0be5ddf6b5d88082f5e01aa1aa100ba7c22bd4': {
    address: '0xbf0be5ddf6b5d88082f5e01aa1aa100ba7c22bd4',
    allocation: '416315000000000',
    sFLOOR: '416315',
  },
  '0x0d3638fa31d8d323e42cc5f44a68462b625d3bd7': {
    address: '0x0d3638fa31d8d323e42cc5f44a68462b625d3bd7',
    allocation: '93145000000000',
    sFLOOR: '93145',
  },
  '0x8bcfc7a0990d3853daa69018a8e9471e0757385c': {
    address: '0x8bcfc7a0990d3853daa69018a8e9471e0757385c',
    allocation: '675336467990000041984',
    aFLOOR: '675336467990',
  },
  '0xd9d4e0f4c81d13edf3ee8cec6ff026a06d418301': {
    address: '0xd9d4e0f4c81d13edf3ee8cec6ff026a06d418301',
    allocation: '655480726900999979008',
    aFLOOR: '655480726901',
  },
  '0xd7ddf70125342f44e65ccbafae5135f2bb6526bb': {
    address: '0xd7ddf70125342f44e65ccbafae5135f2bb6526bb',
    allocation: '200000000000000000000',
    aFLOOR: '200000000000',
  },
  '0xcb63de5613de3add32a48c6736f34e1c8de5281b': {
    address: '0xcb63de5613de3add32a48c6736f34e1c8de5281b',
    allocation: '36490902668999999488',
    aFLOOR: '36490902669',
  },
  '0xec33f6bff72f7328f7532d5b70f76047ea3fdaba': {
    address: '0xec33f6bff72f7328f7532d5b70f76047ea3fdaba',
    allocation: '31942463670000001024',
    aFLOOR: '31942463670',
  },
  '0x79b442b20f146434bf67be912b37627ee5175700': {
    address: '0x79b442b20f146434bf67be912b37627ee5175700',
    allocation: '14165488417999998976',
    aFLOOR: '14165488418',
  },
  '0x0997bcfef1aeef9772d1255f5983996c64c55fcc': {
    address: '0x0997bcfef1aeef9772d1255f5983996c64c55fcc',
    allocation: '12361156059000000512',
    aFLOOR: '12361156059',
  },
  '0x10239c8075e6d678480e33026485756562b814d2': {
    address: '0x10239c8075e6d678480e33026485756562b814d2',
    allocation: '11932585748000000000',
    aFLOOR: '11932585748',
  },
  '0xaa584127b91100dde6b52228c28848a7b1d059c9': {
    address: '0xaa584127b91100dde6b52228c28848a7b1d059c9',
    allocation: '9304713819000000512',
    aFLOOR: '9304713819',
  },
  '0x22631899bd6ae483be7d01ee11315b9f83020175': {
    address: '0x22631899bd6ae483be7d01ee11315b9f83020175',
    allocation: '8420125668000000000',
    aFLOOR: '8420125668',
  },
  '0x481305138b5da49d7828cf74f2827f67292286f3': {
    address: '0x481305138b5da49d7828cf74f2827f67292286f3',
    allocation: '7884367252999999488',
    aFLOOR: '7884367253',
  },
  '0x9e30120c6c5f18bdd515dfefcc55e1b671538cff': {
    address: '0x9e30120c6c5f18bdd515dfefcc55e1b671538cff',
    allocation: '6077366003000000512',
    aFLOOR: '6077366003',
  },
  '0xbf21631a32d29ae104abe7be02451dd2040d9f56': {
    address: '0xbf21631a32d29ae104abe7be02451dd2040d9f56',
    allocation: '5635146580999999488',
    aFLOOR: '5635146581',
  },
  '0x8a08e3ce6ced24d376a13c544e45d4dda02fafea': {
    address: '0x8a08e3ce6ced24d376a13c544e45d4dda02fafea',
    allocation: '5332500327000000512',
    aFLOOR: '5332500327',
  },
  '0x60a9e54a381f23fb46138ac944a8b64a06e068a9': {
    address: '0x60a9e54a381f23fb46138ac944a8b64a06e068a9',
    allocation: '4525107175000000000',
    aFLOOR: '4525107175',
  },
  '0xfd5ae84e4e452137a4827c812af32c86194a7e5d': {
    address: '0xfd5ae84e4e452137a4827c812af32c86194a7e5d',
    allocation: '4478962809000000000',
    aFLOOR: '4478962809',
  },
  '0xdd6b3accd6d5af7208524c5025080235d3f63087': {
    address: '0xdd6b3accd6d5af7208524c5025080235d3f63087',
    allocation: '4417932873000000000',
    aFLOOR: '4417932873',
  },
  '0x7ab4a0973047e2a17aede3a96d1529f8eaf24ddf': {
    address: '0x7ab4a0973047e2a17aede3a96d1529f8eaf24ddf',
    allocation: '3110876918000000000',
    aFLOOR: '3110876918',
  },
  '0x79c3f1b0598b5f1a84cff0701f25eae7c9548b6a': {
    address: '0x79c3f1b0598b5f1a84cff0701f25eae7c9548b6a',
    allocation: '2996749277000000000',
    aFLOOR: '2996749277',
  },
  '0xe2b1081dc27703f36b444665254b0bda0ee9ed27': {
    address: '0xe2b1081dc27703f36b444665254b0bda0ee9ed27',
    allocation: '1000000000000000000',
    aFLOOR: '1000000000',
  },
  '0xce2c27670fbc59e6eb20944fc21d28b973488c24': {
    address: '0xce2c27670fbc59e6eb20944fc21d28b973488c24',
    allocation: '27935000000000',
    aFLOOR: '27935',
  },
  '0xce6185d140fd56382ff248a8adf9b41dd42c71c5': {
    address: '0xce6185d140fd56382ff248a8adf9b41dd42c71c5',
    allocation: '58000000000',
    aFLOOR: '58',
  },
  '0xba12222222228d8ba445958a75a0704d566bf2c8': {
    address: '0xba12222222228d8ba445958a75a0704d566bf2c8',
    allocation: '1000000000',
    aFLOOR: '1',
  },
};

export default MerkleClaimAccounts;
